/* tslint:disable */
export default `
@charset "UTF-8";
/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-component, .bmpui-ui-container, .bmpui-ui-uicontainer, .bmpui-ui-controlbar, .bmpui-ui-settings-panel, .bmpui-ui-listbox, .bmpui-ui-seekbar-label, .bmpui-ui-uicontainer .bmpui-ui-subtitle-overlay, .bmpui-ui-volumecontrolbutton, .bmpui-ui-cast-status-overlay, .bmpui-ui-errormessage-overlay, .bmpui-ui-titlebar, .bmpui-ui-recommendation-overlay, .bmpui-ui-buffering-overlay, .bmpui-ui-playbacktoggle-overlay, .bmpui-ui-button, .bmpui-ui-playbacktogglebutton, .bmpui-ui-fullscreentogglebutton, .bmpui-ui-vrtogglebutton, .bmpui-ui-volumetogglebutton, .bmpui-ui-hugeplaybacktogglebutton, .bmpui-ui-settingspanelpageopenbutton, .bmpui-ui-settingspanelpagebackbutton, .bmpui-ui-settingstogglebutton, .bmpui-ui-subtitlesettingstogglebutton, .bmpui-ui-audiotracksettingstogglebutton, .bmpui-ui-listbox .bmpui-ui-listbox-button, .bmpui-ui-casttogglebutton, .bmpui-ui-watermark, .bmpui-ui-clickoverlay, .bmpui-ui-hugereplaybutton, .bmpui-ui-closebutton, .bmpui-ui-airplaytogglebutton, .bmpui-ui-piptogglebutton, .bmpui-ui-subtitlesettingsresetbutton, .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-ui-button-ad-skip, .bmpui-ui-seekbar, .bmpui-ui-volumeslider, .bmpui-ui-label, .bmpui-ui-playbacktimelabel, .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-ui-label-ad-message, .bmpui-ui-selectbox, .bmpui-ui-spacer {
  /*! placeholder to avoid removal of empty selector */
  outline: 0; }

.bmpui-ui-container, .bmpui-ui-uicontainer, .bmpui-ui-controlbar, .bmpui-ui-settings-panel, .bmpui-ui-listbox, .bmpui-ui-seekbar-label, .bmpui-ui-uicontainer .bmpui-ui-subtitle-overlay, .bmpui-ui-volumecontrolbutton, .bmpui-ui-cast-status-overlay, .bmpui-ui-errormessage-overlay, .bmpui-ui-titlebar, .bmpui-ui-recommendation-overlay, .bmpui-ui-buffering-overlay, .bmpui-ui-playbacktoggle-overlay {
  font-size: 1em; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-uicontainer {
  height: 100%;
  left: 0;
  margin: 0;
  position: absolute;
  top: 0;
  width: 100%;
  font-size: 1em;
  overflow: hidden;
  pointer-events: none; }
  .bmpui-ui-uicontainer * {
    pointer-events: auto; }
  .bmpui-ui-uicontainer.bmpui-hidden {
    display: none; }
  .bmpui-ui-uicontainer.bmpui-player-state-playing.bmpui-controls-hidden * {
    cursor: none; }
  .bmpui-ui-uicontainer.bmpui-controls-shown .bmpui-ui-hugeplaybacktogglebutton:focus {
    box-shadow: inset -4px -3px 2px 9px #1b7fcc; }
  .bmpui-ui-uicontainer.bmpui-controls-shown .bmpui-ui-hugeplaybacktogglebutton:focus:not(.bmpui-focus-visible) {
    box-shadow: none; }
  .bmpui-ui-uicontainer.bmpui-no-flexbox {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="); }
    .bmpui-ui-uicontainer.bmpui-no-flexbox.bmpui-fullscreen {
      left: 0;
      position: fixed;
      top: 0;
      z-index: 999999; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-controlbar {
  opacity: 1;
  transition: opacity 0.3s, visibility 0s;
  bottom: 0;
  position: absolute;
  width: 100%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7));
  box-sizing: border-box;
  line-height: 1em;
  padding: 1em 1em .5em; }
  .bmpui-ui-controlbar.bmpui-hidden {
    opacity: 0;
    transition: opacity 0.3s; }
  .bmpui-ui-controlbar .bmpui-controlbar-top > .bmpui-container-wrapper,
  .bmpui-ui-controlbar .bmpui-controlbar-bottom > .bmpui-container-wrapper {
    display: flex;
    margin: .5em 0; }
  .bmpui-ui-controlbar .bmpui-controlbar-top .bmpui-ui-label {
    font-size: .9em; }
  .bmpui-ui-controlbar .bmpui-controlbar-top > .bmpui-container-wrapper > * {
    margin: 0 .5em; }
  .bmpui-ui-controlbar .bmpui-controlbar-bottom {
    white-space: nowrap; }
    .bmpui-ui-controlbar .bmpui-controlbar-bottom > .bmpui-container-wrapper .bmpui-ui-volumeslider {
      margin: auto .5em;
      width: 5em; }

.bmpui-no-flexbox .bmpui-ui-controlbar .bmpui-controlbar-top > .bmpui-container-wrapper,
.bmpui-no-flexbox .bmpui-ui-controlbar .bmpui-controlbar-bottom > .bmpui-container-wrapper {
  border-spacing: .5em 0;
  display: table; }
  .bmpui-no-flexbox .bmpui-ui-controlbar .bmpui-controlbar-top > .bmpui-container-wrapper > *,
  .bmpui-no-flexbox .bmpui-ui-controlbar .bmpui-controlbar-bottom > .bmpui-container-wrapper > * {
    display: table-cell;
    vertical-align: middle; }
    .bmpui-no-flexbox .bmpui-ui-controlbar .bmpui-controlbar-top > .bmpui-container-wrapper > *.bmpui-hidden,
    .bmpui-no-flexbox .bmpui-ui-controlbar .bmpui-controlbar-bottom > .bmpui-container-wrapper > *.bmpui-hidden {
      display: none; }
  .bmpui-no-flexbox .bmpui-ui-controlbar .bmpui-controlbar-top > .bmpui-container-wrapper .bmpui-ui-volumeslider,
  .bmpui-no-flexbox .bmpui-ui-controlbar .bmpui-controlbar-bottom > .bmpui-container-wrapper .bmpui-ui-volumeslider {
    width: 10%; }

.bmpui-ui-button, .bmpui-ui-playbacktogglebutton, .bmpui-ui-fullscreentogglebutton, .bmpui-ui-vrtogglebutton, .bmpui-ui-volumetogglebutton, .bmpui-ui-hugeplaybacktogglebutton, .bmpui-ui-settingspanelpageopenbutton, .bmpui-ui-settingspanelpagebackbutton, .bmpui-ui-settingstogglebutton, .bmpui-ui-subtitlesettingstogglebutton, .bmpui-ui-audiotracksettingstogglebutton, .bmpui-ui-listbox .bmpui-ui-listbox-button, .bmpui-ui-casttogglebutton, .bmpui-ui-watermark, .bmpui-ui-clickoverlay, .bmpui-ui-hugereplaybutton, .bmpui-ui-closebutton, .bmpui-ui-airplaytogglebutton, .bmpui-ui-piptogglebutton, .bmpui-ui-subtitlesettingsresetbutton, .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-ui-button-ad-skip {
  background-color: transparent;
  background-origin: content-box;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 1.5em;
  border: 0;
  box-sizing: content-box;
  cursor: pointer;
  font-size: 1em;
  height: 1.5em;
  min-width: 1.5em;
  padding: .25em; }
  .bmpui-ui-button .bmpui-label, .bmpui-ui-playbacktogglebutton .bmpui-label, .bmpui-ui-fullscreentogglebutton .bmpui-label, .bmpui-ui-vrtogglebutton .bmpui-label, .bmpui-ui-volumetogglebutton .bmpui-label, .bmpui-ui-hugeplaybacktogglebutton .bmpui-label, .bmpui-ui-settingspanelpageopenbutton .bmpui-label, .bmpui-ui-settingspanelpagebackbutton .bmpui-label, .bmpui-ui-settingstogglebutton .bmpui-label, .bmpui-ui-subtitlesettingstogglebutton .bmpui-label, .bmpui-ui-audiotracksettingstogglebutton .bmpui-label, .bmpui-ui-listbox .bmpui-ui-listbox-button .bmpui-label, .bmpui-ui-casttogglebutton .bmpui-label, .bmpui-ui-watermark .bmpui-label, .bmpui-ui-clickoverlay .bmpui-label, .bmpui-ui-hugereplaybutton .bmpui-label, .bmpui-ui-closebutton .bmpui-label, .bmpui-ui-airplaytogglebutton .bmpui-label, .bmpui-ui-piptogglebutton .bmpui-label, .bmpui-ui-subtitlesettingsresetbutton .bmpui-label, .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-ui-button-ad-skip .bmpui-label {
    color: #fff;
    display: none; }
  .bmpui-disabled.bmpui-ui-button, .bmpui-disabled.bmpui-ui-playbacktogglebutton, .bmpui-disabled.bmpui-ui-fullscreentogglebutton, .bmpui-disabled.bmpui-ui-vrtogglebutton, .bmpui-disabled.bmpui-ui-volumetogglebutton, .bmpui-disabled.bmpui-ui-hugeplaybacktogglebutton, .bmpui-disabled.bmpui-ui-settingspanelpageopenbutton, .bmpui-disabled.bmpui-ui-settingspanelpagebackbutton, .bmpui-disabled.bmpui-ui-settingstogglebutton, .bmpui-disabled.bmpui-ui-subtitlesettingstogglebutton, .bmpui-disabled.bmpui-ui-audiotracksettingstogglebutton, .bmpui-ui-listbox .bmpui-disabled.bmpui-ui-listbox-button, .bmpui-disabled.bmpui-ui-casttogglebutton, .bmpui-disabled.bmpui-ui-watermark, .bmpui-disabled.bmpui-ui-clickoverlay, .bmpui-disabled.bmpui-ui-hugereplaybutton, .bmpui-disabled.bmpui-ui-closebutton, .bmpui-disabled.bmpui-ui-airplaytogglebutton, .bmpui-disabled.bmpui-ui-piptogglebutton, .bmpui-disabled.bmpui-ui-subtitlesettingsresetbutton, .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-disabled.bmpui-ui-button-ad-skip {
    cursor: default; }
    .bmpui-disabled.bmpui-ui-button, .bmpui-disabled.bmpui-ui-playbacktogglebutton, .bmpui-disabled.bmpui-ui-fullscreentogglebutton, .bmpui-disabled.bmpui-ui-vrtogglebutton, .bmpui-disabled.bmpui-ui-volumetogglebutton, .bmpui-disabled.bmpui-ui-hugeplaybacktogglebutton, .bmpui-disabled.bmpui-ui-settingspanelpageopenbutton, .bmpui-disabled.bmpui-ui-settingspanelpagebackbutton, .bmpui-disabled.bmpui-ui-settingstogglebutton, .bmpui-disabled.bmpui-ui-subtitlesettingstogglebutton, .bmpui-disabled.bmpui-ui-audiotracksettingstogglebutton, .bmpui-ui-listbox .bmpui-disabled.bmpui-ui-listbox-button, .bmpui-disabled.bmpui-ui-casttogglebutton, .bmpui-disabled.bmpui-ui-watermark, .bmpui-disabled.bmpui-ui-clickoverlay, .bmpui-disabled.bmpui-ui-hugereplaybutton, .bmpui-disabled.bmpui-ui-closebutton, .bmpui-disabled.bmpui-ui-airplaytogglebutton, .bmpui-disabled.bmpui-ui-piptogglebutton, .bmpui-disabled.bmpui-ui-subtitlesettingsresetbutton, .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-disabled.bmpui-ui-button-ad-skip,
    .bmpui-disabled.bmpui-ui-button > *,
    .bmpui-disabled.bmpui-ui-playbacktogglebutton > *,
    .bmpui-disabled.bmpui-ui-fullscreentogglebutton > *,
    .bmpui-disabled.bmpui-ui-vrtogglebutton > *,
    .bmpui-disabled.bmpui-ui-volumetogglebutton > *,
    .bmpui-disabled.bmpui-ui-hugeplaybacktogglebutton > *,
    .bmpui-disabled.bmpui-ui-settingspanelpageopenbutton > *,
    .bmpui-disabled.bmpui-ui-settingspanelpagebackbutton > *,
    .bmpui-disabled.bmpui-ui-settingstogglebutton > *,
    .bmpui-disabled.bmpui-ui-subtitlesettingstogglebutton > *,
    .bmpui-disabled.bmpui-ui-audiotracksettingstogglebutton > *,
    .bmpui-ui-listbox .bmpui-disabled.bmpui-ui-listbox-button > *,
    .bmpui-disabled.bmpui-ui-casttogglebutton > *,
    .bmpui-disabled.bmpui-ui-watermark > *,
    .bmpui-disabled.bmpui-ui-clickoverlay > *,
    .bmpui-disabled.bmpui-ui-hugereplaybutton > *,
    .bmpui-disabled.bmpui-ui-closebutton > *,
    .bmpui-disabled.bmpui-ui-airplaytogglebutton > *,
    .bmpui-disabled.bmpui-ui-piptogglebutton > *,
    .bmpui-disabled.bmpui-ui-subtitlesettingsresetbutton > *,
    .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-disabled.bmpui-ui-button-ad-skip > * {
      pointer-events: none; }
    .bmpui-disabled.bmpui-ui-button .bmpui-label:hover, .bmpui-disabled.bmpui-ui-playbacktogglebutton .bmpui-label:hover, .bmpui-disabled.bmpui-ui-fullscreentogglebutton .bmpui-label:hover, .bmpui-disabled.bmpui-ui-vrtogglebutton .bmpui-label:hover, .bmpui-disabled.bmpui-ui-volumetogglebutton .bmpui-label:hover, .bmpui-disabled.bmpui-ui-hugeplaybacktogglebutton .bmpui-label:hover, .bmpui-disabled.bmpui-ui-settingspanelpageopenbutton .bmpui-label:hover, .bmpui-disabled.bmpui-ui-settingspanelpagebackbutton .bmpui-label:hover, .bmpui-disabled.bmpui-ui-settingstogglebutton .bmpui-label:hover, .bmpui-disabled.bmpui-ui-subtitlesettingstogglebutton .bmpui-label:hover, .bmpui-disabled.bmpui-ui-audiotracksettingstogglebutton .bmpui-label:hover, .bmpui-ui-listbox .bmpui-disabled.bmpui-ui-listbox-button .bmpui-label:hover, .bmpui-disabled.bmpui-ui-casttogglebutton .bmpui-label:hover, .bmpui-disabled.bmpui-ui-watermark .bmpui-label:hover, .bmpui-disabled.bmpui-ui-clickoverlay .bmpui-label:hover, .bmpui-disabled.bmpui-ui-hugereplaybutton .bmpui-label:hover, .bmpui-disabled.bmpui-ui-closebutton .bmpui-label:hover, .bmpui-disabled.bmpui-ui-airplaytogglebutton .bmpui-label:hover, .bmpui-disabled.bmpui-ui-piptogglebutton .bmpui-label:hover, .bmpui-disabled.bmpui-ui-subtitlesettingsresetbutton .bmpui-label:hover, .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-disabled.bmpui-ui-button-ad-skip .bmpui-label:hover {
      text-decoration: none; }
  .bmpui-hidden.bmpui-ui-button, .bmpui-hidden.bmpui-ui-playbacktogglebutton, .bmpui-hidden.bmpui-ui-fullscreentogglebutton, .bmpui-hidden.bmpui-ui-vrtogglebutton, .bmpui-hidden.bmpui-ui-volumetogglebutton, .bmpui-hidden.bmpui-ui-hugeplaybacktogglebutton, .bmpui-hidden.bmpui-ui-settingspanelpageopenbutton, .bmpui-hidden.bmpui-ui-settingspanelpagebackbutton, .bmpui-hidden.bmpui-ui-settingstogglebutton, .bmpui-hidden.bmpui-ui-subtitlesettingstogglebutton, .bmpui-hidden.bmpui-ui-audiotracksettingstogglebutton, .bmpui-ui-listbox .bmpui-hidden.bmpui-ui-listbox-button, .bmpui-hidden.bmpui-ui-casttogglebutton, .bmpui-hidden.bmpui-ui-watermark, .bmpui-hidden.bmpui-ui-clickoverlay, .bmpui-hidden.bmpui-ui-hugereplaybutton, .bmpui-hidden.bmpui-ui-closebutton, .bmpui-hidden.bmpui-ui-airplaytogglebutton, .bmpui-hidden.bmpui-ui-piptogglebutton, .bmpui-hidden.bmpui-ui-subtitlesettingsresetbutton, .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-hidden.bmpui-ui-button-ad-skip {
    display: none; }
  .bmpui-ui-button:focus, .bmpui-ui-playbacktogglebutton:focus, .bmpui-ui-fullscreentogglebutton:focus, .bmpui-ui-vrtogglebutton:focus, .bmpui-ui-volumetogglebutton:focus, .bmpui-ui-hugeplaybacktogglebutton:focus, .bmpui-ui-settingspanelpageopenbutton:focus, .bmpui-ui-settingspanelpagebackbutton:focus, .bmpui-ui-settingstogglebutton:focus, .bmpui-ui-subtitlesettingstogglebutton:focus, .bmpui-ui-audiotracksettingstogglebutton:focus, .bmpui-ui-listbox .bmpui-ui-listbox-button:focus, .bmpui-ui-casttogglebutton:focus, .bmpui-ui-watermark:focus, .bmpui-ui-clickoverlay:focus, .bmpui-ui-hugereplaybutton:focus, .bmpui-ui-closebutton:focus, .bmpui-ui-airplaytogglebutton:focus, .bmpui-ui-piptogglebutton:focus, .bmpui-ui-subtitlesettingsresetbutton:focus, .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-ui-button-ad-skip:focus {
    box-shadow: 0 0 0 2px rgba(27, 127, 204, 0.8);
    outline: none; }
  .bmpui-ui-button:focus:not(.bmpui-focus-visible), .bmpui-ui-playbacktogglebutton:focus:not(.bmpui-focus-visible), .bmpui-ui-fullscreentogglebutton:focus:not(.bmpui-focus-visible), .bmpui-ui-vrtogglebutton:focus:not(.bmpui-focus-visible), .bmpui-ui-volumetogglebutton:focus:not(.bmpui-focus-visible), .bmpui-ui-hugeplaybacktogglebutton:focus:not(.bmpui-focus-visible), .bmpui-ui-settingspanelpageopenbutton:focus:not(.bmpui-focus-visible), .bmpui-ui-settingspanelpagebackbutton:focus:not(.bmpui-focus-visible), .bmpui-ui-settingstogglebutton:focus:not(.bmpui-focus-visible), .bmpui-ui-subtitlesettingstogglebutton:focus:not(.bmpui-focus-visible), .bmpui-ui-audiotracksettingstogglebutton:focus:not(.bmpui-focus-visible), .bmpui-ui-listbox .bmpui-ui-listbox-button:focus:not(.bmpui-focus-visible), .bmpui-ui-casttogglebutton:focus:not(.bmpui-focus-visible), .bmpui-ui-watermark:focus:not(.bmpui-focus-visible), .bmpui-ui-clickoverlay:focus:not(.bmpui-focus-visible), .bmpui-ui-hugereplaybutton:focus:not(.bmpui-focus-visible), .bmpui-ui-closebutton:focus:not(.bmpui-focus-visible), .bmpui-ui-airplaytogglebutton:focus:not(.bmpui-focus-visible), .bmpui-ui-piptogglebutton:focus:not(.bmpui-focus-visible), .bmpui-ui-subtitlesettingsresetbutton:focus:not(.bmpui-focus-visible), .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-ui-button-ad-skip:focus:not(.bmpui-focus-visible) {
    box-shadow: none;
    outline: none; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-playbacktogglebutton {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-play%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7%206.08445C7%204.99428%207.77922%204%208.86233%204C9.22128%204%209.56872%204.11584%209.86512%204.32772L18.1408%2010.2432C19.0091%2010.8639%2019.2422%2012.1267%2018.7349%2013.073C18.5889%2013.3453%2018.3869%2013.5808%2018.1408%2013.7567L9.86512%2019.6721C8.95894%2020.3199%207.79138%2019.9692%207.26553%2018.9885C7.09037%2018.6618%207%2018.2904%207%2017.9154V6.08445Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3C/svg%3E"); }
  .bmpui-ui-playbacktogglebutton:hover {
    filter: drop-shadow(0 0 1px #fff); }
  .bmpui-ui-playbacktogglebutton.bmpui-on {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-pause%22%3E%3Cpath%20d%3D%22M6%206C6%204.89543%206.89543%204%208%204C9.10457%204%2010%204.89543%2010%206V18C10%2019.1046%209.10457%2020%208%2020C6.89543%2020%206%2019.1046%206%2018V6Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3Cpath%20d%3D%22M14%206C14%204.89543%2014.8954%204%2016%204C17.1046%204%2018%204.89543%2018%206V18C18%2019.1046%2017.1046%2020%2016%2020C14.8954%2020%2014%2019.1046%2014%2018V6Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3C/svg%3E"); }
    .bmpui-ui-playbacktogglebutton.bmpui-on.bmpui-stoptoggle {
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-stop%22%3E%3Cpath%20d%3D%22M4%207C4%205.34315%205.34315%204%207%204H17C18.6569%204%2020%205.34315%2020%207V17C20%2018.6569%2018.6569%2020%2017%2020H7C5.34315%2020%204%2018.6569%204%2017V7Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3C/svg%3E"); }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-fullscreentogglebutton {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-fullscreen%22%3E%3Cpath%20d%3D%22M9%204L6%204C4.89543%204%204%204.89543%204%206L4%209%22%20stroke%3D%22%23INACTIVE%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C/path%3E%3Cpath%20d%3D%22M15%2020L18%2020C19.1046%2020%2020%2019.1046%2020%2018L20%2015%22%20stroke%3D%22%23INACTIVE%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C/path%3E%3Cpath%20d%3D%22M4%2015L4%2018C4%2019.1046%204.89543%2020%206%2020L9%2020%22%20stroke%3D%22%23INACTIVE%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C/path%3E%3Cpath%20d%3D%22M20%209L20%206C20%204.89543%2019.1046%204%2018%204L15%204%22%20stroke%3D%22%23INACTIVE%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C/path%3E%3C/svg%3E"); }
  .bmpui-ui-fullscreentogglebutton:hover {
    filter: drop-shadow(0 0 1px #fff); }
  .bmpui-ui-fullscreentogglebutton.bmpui-on {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23ACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-fullscreenX%22%3E%3Cpath%20d%3D%22M9%204L6%204C4.89543%204%204%204.89543%204%206L4%209%22%20stroke%3D%22%23ACTIVE%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C/path%3E%3Cpath%20d%3D%22M15%2020L18%2020C19.1046%2020%2020%2019.1046%2020%2018L20%2015%22%20stroke%3D%22%23ACTIVE%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C/path%3E%3Cpath%20d%3D%22M4%2015L4%2018C4%2019.1046%204.89543%2020%206%2020L9%2020%22%20stroke%3D%22%23ACTIVE%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C/path%3E%3Cpath%20d%3D%22M20%209L20%206C20%204.89543%2019.1046%204%2018%204L15%204%22%20stroke%3D%22%23ACTIVE%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C/path%3E%3C/svg%3E"); }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-vrtogglebutton {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20id%3D%22npo-icon-glasses%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2032%2032%22%20style%3D%22enable-background%3Anew%200%200%2032%2032%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text/css%22%3E%09.st0%7Bfill%3A%23INACTIVE%3B%7D%3C/style%3E%3Cg%20id%3D%22Rectangle_9%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st0%22%20d%3D%22M29%2C5.4H3c-1.3%2C0-2.4%2C1.1-2.4%2C2.4v16.5c0%2C1.3%2C1.1%2C2.4%2C2.4%2C2.4h9.4v-2.4H3V7.7h26v16.5h-9.4v2.4H29%09%09%09c1.3%2C0%2C2.4-1.1%2C2.4-2.4V7.7C31.4%2C6.4%2C30.3%2C5.4%2C29%2C5.4z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3Cg%20id%3D%22v%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st0%22%20d%3D%22M10.1%2C11.3c-2.6%2C0-4.7%2C2.1-4.7%2C4.7s2.1%2C4.7%2C4.7%2C4.7s4.7-2.1%2C4.7-4.7S12.7%2C11.3%2C10.1%2C11.3z%20M10.1%2C18.4%09%09%09c-1.3%2C0-2.4-1.1-2.4-2.4s1.1-2.4%2C2.4-2.4s2.4%2C1.1%2C2.4%2C2.4S11.4%2C18.4%2C10.1%2C18.4z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3Cg%20id%3D%22v_copy%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st0%22%20d%3D%22M21.9%2C11.3c-2.6%2C0-4.7%2C2.1-4.7%2C4.7s2.1%2C4.7%2C4.7%2C4.7s4.7-2.1%2C4.7-4.7S24.5%2C11.3%2C21.9%2C11.3z%20M21.9%2C18.4%09%09%09c-1.3%2C0-2.4-1.1-2.4-2.4s1.1-2.4%2C2.4-2.4s2.4%2C1.1%2C2.4%2C2.4S23.2%2C18.4%2C21.9%2C18.4z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3Cg%20id%3D%22Rectangle_10%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st0%22%20d%3D%22M16%2C23.1c2%2C0%2C3.5%2C1.5%2C3.5%2C3.5h2.4c0-3.3-2.6-5.9-5.9-5.9s-5.9%2C2.6-5.9%2C5.9h2.4C12.5%2C24.6%2C14%2C23.1%2C16%2C23.1z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3C/svg%3E"); }
  .bmpui-ui-vrtogglebutton:hover {
    filter: drop-shadow(0 0 1px #fff); }
  .bmpui-ui-vrtogglebutton.bmpui-on {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20id%3D%22npo-icon-glassesX%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2032%2032%22%20style%3D%22enable-background%3Anew%200%200%2032%2032%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text/css%22%3E%09.st0%7Bopacity%3A0.302%3B%7D%09.st1%7Bfill%3A%23INACTIVE%3B%7D%3C/style%3E%3Cg%20id%3D%22Rectangle_25%22%20class%3D%22st0%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st1%22%20d%3D%22M3%2C7.7v16.5h10.6v-2.4h4.7v2.4H29V7.7H3z%20M7.7%2C19.5v-7.1h5.9v7.1H7.7z%20M25.4%2C19.5h-7.1v-7.1h7.1V19.5z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3Cg%20id%3D%22Rectangle_10_1_%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st1%22%20d%3D%22M21.9%2C20.7c2.6%2C0%2C4.7-2.1%2C4.7-4.7s-2.1-4.7-4.7-4.7s-4.7%2C2.1-4.7%2C4.7S19.3%2C20.7%2C21.9%2C20.7z%20M21.9%2C13.6%09%09%09c1.3%2C0%2C2.4%2C1.1%2C2.4%2C2.4s-1.1%2C2.4-2.4%2C2.4s-2.4-1.1-2.4-2.4S20.6%2C13.6%2C21.9%2C13.6z%20M10.1%2C20.7c2.6%2C0%2C4.7-2.1%2C4.7-4.7%09%09%09s-2.1-4.7-4.7-4.7S5.4%2C13.4%2C5.4%2C16S7.5%2C20.7%2C10.1%2C20.7z%20M10.1%2C13.6c1.3%2C0%2C2.4%2C1.1%2C2.4%2C2.4s-1.1%2C2.4-2.4%2C2.4S7.7%2C17.3%2C7.7%2C16%09%09%09S8.8%2C13.6%2C10.1%2C13.6z%20M29%2C5.4H3c-1.3%2C0-2.4%2C1.1-2.4%2C2.4v16.5c0%2C1.3%2C1.1%2C2.4%2C2.4%2C2.4h9.4c0-2%2C1.5-3.5%2C3.5-3.5s3.5%2C1.5%2C3.5%2C3.5H29%09%09%09c1.3%2C0%2C2.4-1.1%2C2.4-2.4V7.7C31.4%2C6.4%2C30.3%2C5.4%2C29%2C5.4z%20M29%2C24.3h-7.6c-0.9-2.1-3-3.5-5.4-3.5s-4.5%2C1.4-5.4%2C3.5H3V7.7h26V24.3z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3C/svg%3E"); }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-volumetogglebutton:hover {
  filter: drop-shadow(0 0 1px #fff); }

.bmpui-ui-volumetogglebutton.bmpui-muted {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-music-off%22%3E%3Cpath%20d%3D%22M3%208H6.5L11.4759%204.93791C12.1422%204.52789%2013%205.00724%2013%205.78956V18.2104C13%2018.9928%2012.1422%2019.4721%2011.4759%2019.0621L6.5%2016H3C2.44772%2016%202%2015.5523%202%2015V9C2%208.44772%202.44772%208%203%208Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3Cpath%20d%3D%22M21.2164%208.30602C21.6244%207.89799%2022.2859%207.89799%2022.694%208.30602C23.102%208.71404%2023.102%209.37559%2022.694%209.78361L16.7836%2015.694C16.3756%2016.102%2015.714%2016.102%2015.306%2015.694C14.898%2015.286%2014.898%2014.6244%2015.306%2014.2164L21.2164%208.30602Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3Cpath%20d%3D%22M15.306%209.78361C14.898%209.37559%2014.898%208.71405%2015.306%208.30602C15.7141%207.898%2016.3756%207.898%2016.7836%208.30602L22.694%2014.2164C23.102%2014.6244%2023.102%2015.286%2022.694%2015.694C22.286%2016.102%2021.6244%2016.102%2021.2164%2015.694L15.306%209.78361Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3C/svg%3E"); }

.bmpui-ui-volumetogglebutton.bmpui-unmuted[data-bmpui-volume-level-tens='0'] {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-music-off%22%3E%3Cpath%20d%3D%22M3%208H6.5L11.4759%204.93791C12.1422%204.52789%2013%205.00724%2013%205.78956V18.2104C13%2018.9928%2012.1422%2019.4721%2011.4759%2019.0621L6.5%2016H3C2.44772%2016%202%2015.5523%202%2015V9C2%208.44772%202.44772%208%203%208Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3Cpath%20d%3D%22M21.2164%208.30602C21.6244%207.89799%2022.2859%207.89799%2022.694%208.30602C23.102%208.71404%2023.102%209.37559%2022.694%209.78361L16.7836%2015.694C16.3756%2016.102%2015.714%2016.102%2015.306%2015.694C14.898%2015.286%2014.898%2014.6244%2015.306%2014.2164L21.2164%208.30602Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3Cpath%20d%3D%22M15.306%209.78361C14.898%209.37559%2014.898%208.71405%2015.306%208.30602C15.7141%207.898%2016.3756%207.898%2016.7836%208.30602L22.694%2014.2164C23.102%2014.6244%2023.102%2015.286%2022.694%2015.694C22.286%2016.102%2021.6244%2016.102%2021.2164%2015.694L15.306%209.78361Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3C/svg%3E"); }

.bmpui-ui-volumetogglebutton.bmpui-unmuted[data-bmpui-volume-level-tens='1'], .bmpui-ui-volumetogglebutton.bmpui-unmuted[data-bmpui-volume-level-tens='2'], .bmpui-ui-volumetogglebutton.bmpui-unmuted[data-bmpui-volume-level-tens='3'], .bmpui-ui-volumetogglebutton.bmpui-unmuted[data-bmpui-volume-level-tens='4'], .bmpui-ui-volumetogglebutton.bmpui-unmuted[data-bmpui-volume-level-tens='5'] {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-music-low%22%3E%3Crect%20x%3D%2214%22%20y%3D%229%22%20width%3D%222%22%20height%3D%226%22%20rx%3D%221%22%20fill%3D%22%23INACTIVE%22%3E%3C/rect%3E%3Cpath%20d%3D%22M3%208H6.5L11.4759%204.93791C12.1422%204.52789%2013%205.00724%2013%205.78956V18.2104C13%2018.9928%2012.1422%2019.4721%2011.4759%2019.0621L6.5%2016H3C2.44772%2016%202%2015.5523%202%2015V9C2%208.44772%202.44772%208%203%208Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3C/svg%3E"); }

.bmpui-ui-volumetogglebutton.bmpui-unmuted[data-bmpui-volume-level-tens='6'], .bmpui-ui-volumetogglebutton.bmpui-unmuted[data-bmpui-volume-level-tens='7'], .bmpui-ui-volumetogglebutton.bmpui-unmuted[data-bmpui-volume-level-tens='8'], .bmpui-ui-volumetogglebutton.bmpui-unmuted[data-bmpui-volume-level-tens='9'], .bmpui-ui-volumetogglebutton.bmpui-unmuted[data-bmpui-volume-level-tens='10'] {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-music-on%22%3E%3Crect%20x%3D%2214%22%20y%3D%229%22%20width%3D%222%22%20height%3D%226%22%20rx%3D%221%22%20fill%3D%22%23INACTIVE%22%3E%3C/rect%3E%3Crect%20x%3D%2217%22%20y%3D%227%22%20width%3D%222%22%20height%3D%2210%22%20rx%3D%221%22%20fill%3D%22%23INACTIVE%22%3E%3C/rect%3E%3Crect%20x%3D%2220%22%20y%3D%224%22%20width%3D%222%22%20height%3D%2216%22%20rx%3D%221%22%20fill%3D%22%23INACTIVE%22%3E%3C/rect%3E%3Cpath%20d%3D%22M3%208H6.5L11.4759%204.93791C12.1422%204.52789%2013%205.00724%2013%205.78956V18.2104C13%2018.9928%2012.1422%2019.4721%2011.4759%2019.0621L6.5%2016H3C2.44772%2016%202%2015.5523%202%2015V9C2%208.44772%202.44772%208%203%208Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3C/svg%3E"); }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-seekbar, .bmpui-ui-volumeslider {
  cursor: pointer;
  font-size: 1em;
  height: 1em;
  position: relative;
  width: 100%; }
  .bmpui-hidden.bmpui-ui-seekbar, .bmpui-hidden.bmpui-ui-volumeslider {
    display: none; }
  .bmpui-ui-seekbar:focus, .bmpui-ui-volumeslider:focus {
    box-shadow: 0 0 0 2px rgba(27, 127, 204, 0.8);
    outline: none; }
  .bmpui-ui-seekbar:focus:not(.bmpui-focus-visible), .bmpui-ui-volumeslider:focus:not(.bmpui-focus-visible) {
    box-shadow: none;
    outline: none; }
  .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-backdrop, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-backdrop, .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-bufferlevel, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-bufferlevel, .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-seekposition, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-seekposition, .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-playbackposition, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-playbackposition, .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-playbackposition-marker, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-playbackposition-marker, .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-markers, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-markers, .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-markers > .bmpui-seekbar-marker, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-markers > .bmpui-seekbar-marker {
    -ms-transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
    bottom: 0;
    box-sizing: border-box;
    height: 0.3125em;
    left: 0;
    margin: auto;
    position: absolute;
    right: auto;
    top: 0;
    transform-origin: 0 0;
    width: 100%; }
  .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-backdrop, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-backdrop {
    background-color: rgba(255, 255, 255, 0.2);
    margin: auto 0;
    width: 100%; }
  .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-bufferlevel, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-bufferlevel {
    background-color: #fff;
    margin: auto 0;
    transition: .3s linear, .3s linear;
    transition-property: transform; }
  .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-seekposition, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-seekposition {
    background-color: rgba(255, 255, 255, 0.2);
    margin: auto 0; }
  .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-playbackposition, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-playbackposition {
    background-color: #1fabe2;
    margin: auto 0;
    transition: .1s linear, .1s linear;
    transition-property: transform; }
  .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-playbackposition-marker, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-playbackposition-marker {
    height: 0.9375em;
    left: -0.46875em;
    width: 0.9375em;
    background-color: rgba(31, 171, 226, 0.5);
    border: solid #1fabe2 0.1875em;
    border-radius: 50%; }
  .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-markers, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-markers {
    height: 0.5625em; }
    .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-markers > .bmpui-seekbar-marker, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-markers > .bmpui-seekbar-marker {
      background-color: #fff;
      height: 100%;
      width: 2px;
      text-align: center;
      transition-property: transform;
      transition-duration: 1s;
      transition-timing-function: linear; }
      .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-markers > .bmpui-seekbar-marker > .bmpui-seekbar-marker-image, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-markers > .bmpui-seekbar-marker > .bmpui-seekbar-marker-image {
        position: absolute;
        height: 1.25em;
        transform: translate(-50%, calc(-100% - .2em)); }
  .bmpui-seeking.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-bufferlevel, .bmpui-seeking.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-bufferlevel,
  .bmpui-seeking.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-playbackposition,
  .bmpui-seeking.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-playbackposition {
    transition: none; }
  .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar {
    height: 100%;
    width: auto; }
    .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-backdrop, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-backdrop, .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-bufferlevel, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-bufferlevel, .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-seekposition, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-seekposition, .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-playbackposition, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-playbackposition {
      right: 0;
      top: auto; }
    .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-playbackposition .bmpui-seekbar-playbackposition-marker, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-playbackposition .bmpui-seekbar-playbackposition-marker {
      height: 1em;
      top: -.5em;
      width: 100%; }
    .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-backdrop, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-backdrop {
      height: 100%;
      margin: 0 auto;
      width: auto; }
    .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-bufferlevel, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-bufferlevel {
      margin: 0 auto; }
    .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-seekposition, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-seekposition {
      margin: 0 auto; }

.bmpui-ui-watermark {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20id%3D%22npo-icon-logo%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2068%2068%22%20style%3D%22enable-background%3Anew%200%200%2068%2068%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text/css%22%3E%09.st0%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3Bfill%3A%23INACTIVE%3B%7D%3C/style%3E%3Cg%20id%3D%22Shape_1%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st0%22%20d%3D%22M63.3%2C32.5L24.3%2C5v13.4l20.4%2C14.5c0.8%2C0.6%2C0.8%2C1.8%2C0%2C2.4L24.3%2C49.6V63l39-27.5C64.2%2C34.7%2C64.2%2C33.3%2C63.3%2C32.5%09%09%09z%20M38%2C32.5L12.8%2C14.7V25l11.1%2C7.9c0.8%2C0.6%2C0.8%2C1.8%2C0%2C2.4L12.8%2C43v10.3L38%2C35.5C39%2C34.7%2C39%2C33.3%2C38%2C32.5z%20M17.2%2C32.6L4%2C23.2v6.5%09%09%09l4.5%2C3.2c0.8%2C0.6%2C0.8%2C1.8%2C0%2C2.4L4%2C38.4v6.5l13.2-9.4C18.2%2C34.7%2C18.2%2C33.3%2C17.2%2C32.6z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-size: initial;
  height: 4em;
  margin: 2em;
  opacity: .8;
  position: absolute;
  right: 0;
  top: 0;
  width: 4em; }
  .bmpui-ui-watermark:hover {
    opacity: 1; }

.bmpui-ui-hugeplaybacktogglebutton {
  cursor: default;
  height: 8em;
  outline: none;
  overflow: hidden;
  width: 8em; }

@keyframes fade-out {
  from {
    opacity: 1;
    visibility: visible; }
  to {
    opacity: 0;
    transform: scale(2);
    visibility: hidden; } }

@keyframes fade-in {
  from {
    opacity: 0;
    transform: scale(2);
    visibility: visible; }
  to {
    opacity: 1; } }

@keyframes breathe {
  30% {
    transform: scale(1.1); }
  60% {
    transform: scale(1); } }
  .bmpui-ui-hugeplaybacktogglebutton .bmpui-image {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-play_big%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7%206.08445C7%204.99428%207.77922%204%208.86233%204C9.22128%204%209.56872%204.11584%209.86512%204.32772L18.1408%2010.2432C19.0091%2010.8639%2019.2422%2012.1267%2018.7349%2013.073C18.5889%2013.3453%2018.3869%2013.5808%2018.1408%2013.7567L9.86512%2019.6721C8.95894%2020.3199%207.79138%2019.9692%207.26553%2018.9885C7.09037%2018.6618%207%2018.2904%207%2017.9154V6.08445Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3C/svg%3E");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 7em;
    height: 100%;
    width: 100%; }
    .bmpui-ui-hugeplaybacktogglebutton .bmpui-image:hover {
      animation: breathe 3s ease-in-out infinite; }
  .bmpui-ui-hugeplaybacktogglebutton.bmpui-on .bmpui-image {
    animation: fade-out 0.3s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    transition: visibility 0s 0.3s;
    visibility: hidden; }
  .bmpui-ui-hugeplaybacktogglebutton.bmpui-off .bmpui-image {
    animation: fade-in 0.3s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    visibility: visible; }
  .bmpui-ui-hugeplaybacktogglebutton.bmpui-no-transition-animations.bmpui-on .bmpui-image, .bmpui-ui-hugeplaybacktogglebutton.bmpui-no-transition-animations.bmpui-off .bmpui-image {
    animation: none;
    transition: none; }

.bmpui-ui-label, .bmpui-ui-playbacktimelabel, .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-ui-label-ad-message {
  cursor: default;
  white-space: nowrap; }
  .bmpui-hidden.bmpui-ui-label, .bmpui-hidden.bmpui-ui-playbacktimelabel, .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-hidden.bmpui-ui-label-ad-message {
    display: none; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-settings-panel {
  opacity: 1;
  transition: opacity 0.3s, visibility 0s;
  visibility: visible;
  transition: opacity 0.3s, visibility 0s, height 0.35s cubic-bezier(0.4, 0, 0.2, 1), width 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: rgba(17, 17, 17, 0.85);
  bottom: 5em;
  overflow: hidden;
  padding: 0;
  position: absolute;
  right: 2em; }
  .bmpui-hidden.bmpui-ui-settings-panel {
    opacity: 0;
    transition: opacity 0.3s, visibility 0.3s;
    visibility: hidden; }
  .bmpui-ui-settings-panel > .bmpui-container-wrapper {
    margin: .5em;
    overflow-y: auto; }
    .bmpui-ui-settings-panel > .bmpui-container-wrapper > * {
      margin: 0 .5em; }

.bmpui-container-wrapper > .bmpui-ui-settings-panel {
  margin: 0; }

.bmpui-ui-settings-panel-page {
  display: none; }
  .bmpui-active.bmpui-ui-settings-panel-page {
    display: block; }
  .bmpui-ui-settings-panel-page .bmpui-container-wrapper > *.bmpui-ui-label {
    display: inline-block;
    font-size: .8em;
    width: 45%; }
  .bmpui-ui-settings-panel-page .bmpui-container-wrapper > *.bmpui-ui-selectbox {
    margin-left: 10%;
    width: 45%; }
  .bmpui-ui-settings-panel-page .bmpui-ui-settings-panel-item {
    border-bottom: 1px solid rgba(153, 153, 153, 0.3);
    padding: .5em 0;
    white-space: nowrap; }
    .bmpui-ui-settings-panel-page .bmpui-ui-settings-panel-item.bmpui-last {
      border-bottom: 0; }
    .bmpui-ui-settings-panel-page .bmpui-ui-settings-panel-item.bmpui-hidden {
      display: none; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-settingspanelpageopenbutton {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20id%3D%22npo-icon-settings%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2032%2032%22%20style%3D%22enable-background%3Anew%200%200%2032%2032%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text/css%22%3E%09.st0%7Bfill%3A%23INACTIVE%3B%7D%3C/style%3E%3Cg%20id%3D%22Shape_4%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st0%22%20d%3D%22M25.6%2C13.8l-1.4-0.3c-0.2-0.5-0.4-1-0.6-1.4l0.9-1.3c0.4-0.5%2C0.3-1.3-0.1-1.7L23%2C7.7c-0.3-0.3-0.6-0.4-1-0.4%09%09%09c-0.3%2C0-0.6%2C0.1-0.8%2C0.3L20%2C8.5c-0.5-0.3-1-0.5-1.5-0.6l-0.3-1.4c0-0.6-0.6-1.1-1.3-1.1H15c-0.7%2C0-1.2%2C0.5-1.3%2C1.1L13.5%2C8%09%09%09c-0.5%2C0.2-1%2C0.4-1.4%2C0.6l-1.3-0.9c-0.2-0.2-0.5-0.3-0.8-0.3c-0.4%2C0-0.7%2C0.1-1%2C0.4L7.8%2C9.1c-0.5%2C0.5-0.5%2C1.2-0.1%2C1.7l0.9%2C1.3%09%09%09c-0.3%2C0.5-0.5%2C1-0.6%2C1.4l-1.4%2C0.3c-0.7%2C0-1.2%2C0.6-1.2%2C1.3V17c0%2C0.7%2C0.5%2C1.2%2C1.1%2C1.3L8%2C18.5c0.2%2C0.5%2C0.4%2C1%2C0.6%2C1.4l-0.9%2C1.3%09%09%09c-0.4%2C0.5-0.3%2C1.3%2C0.1%2C1.7l1.4%2C1.4c0.3%2C0.3%2C0.6%2C0.4%2C1%2C0.4c0.3%2C0%2C0.6-0.1%2C0.8-0.3l1.3-0.9c0.5%2C0.2%2C1%2C0.4%2C1.4%2C0.6l0.3%2C1.4%09%09%09c0.1%2C0.7%2C0.7%2C1.1%2C1.3%2C1.1H17c0.7%2C0%2C1.2-0.5%2C1.3-1.1l0.3-1.4c0.5-0.2%2C1-0.4%2C1.4-0.6l1.3%2C0.9c0.2%2C0.2%2C0.5%2C0.3%2C0.8%2C0.3%09%09%09c0.4%2C0%2C0.7-0.1%2C1-0.4l1.4-1.4c0.5-0.5%2C0.5-1.2%2C0.1-1.7L23.5%2C20c0.3-0.5%2C0.5-1%2C0.6-1.4l1.4-0.3c0.7-0.1%2C1.1-0.7%2C1.1-1.3V15%09%09%09C26.6%2C14.5%2C26.1%2C13.9%2C25.6%2C13.8z%20M24.6%2C16.9L24.6%2C16.9C24.6%2C17%2C24.6%2C17%2C24.6%2C16.9l-1.8%2C0.4c-0.2%2C0-0.4%2C0.2-0.4%2C0.4%09%09%09c-0.2%2C0.6-0.4%2C1.2-0.7%2C1.6c-0.1%2C0.2-0.1%2C0.4%2C0%2C0.6l1%2C1.4v0.1l-1.2%2C1.2h-0.1c0%2C0%2C0%2C0-0.1%2C0l-1.4-1c-0.2-0.1-0.4-0.1-0.6%2C0%09%09%09c-0.5%2C0.3-1.1%2C0.6-1.6%2C0.7c-0.2%2C0.1-0.4%2C0.2-0.4%2C0.4L17%2C24.5c0%2C0.1-0.1%2C0.1-0.1%2C0.1h-1.7c-0.1%2C0-0.1%2C0-0.1-0.1l-0.3-1.7%09%09%09c0-0.2-0.2-0.4-0.4-0.4c-0.6-0.2-1.2-0.4-1.6-0.7c-0.1%2C0-0.2-0.1-0.3-0.1c-0.1%2C0-0.2%2C0-0.3%2C0.1l-1.4%2C1c0%2C0%2C0%2C0-0.1%2C0%09%09%09c0%2C0%2C0%2C0-0.1%2C0l-1.2-1.2v-0.1l1-1.4c0.1-0.2%2C0.1-0.4%2C0-0.6C10%2C19%2C9.7%2C18.4%2C9.6%2C17.8c-0.1-0.2-0.2-0.4-0.4-0.4L7.5%2C17%09%09%09c-0.1%2C0-0.1-0.1-0.1-0.1v-1.7c0-0.1%2C0-0.1%2C0.1-0.1l1.7-0.2c0.2%2C0%2C0.4-0.2%2C0.5-0.4c0.2-0.6%2C0.4-1.2%2C0.7-1.6c0.1-0.2%2C0.1-0.4%2C0-0.6%09%09%09l-1-1.4v-0.1l1.2-1.2h0.1c0%2C0%2C0%2C0%2C0.1%2C0l1.4%2C1c0.2%2C0.1%2C0.4%2C0.1%2C0.6%2C0c0.5-0.3%2C1.1-0.6%2C1.6-0.7c0.2-0.1%2C0.4-0.2%2C0.4-0.4L15%2C7.5%09%09%09c0-0.1%2C0.1-0.1%2C0.1-0.1h1.7c0.1%2C0%2C0.1%2C0%2C0.1%2C0.1l0.2%2C1.7c0%2C0.2%2C0.2%2C0.4%2C0.4%2C0.5c0.6%2C0.2%2C1.2%2C0.4%2C1.7%2C0.7c0.2%2C0.1%2C0.4%2C0.1%2C0.6%2C0%09%09%09l1.4-1c0%2C0%2C0%2C0%2C0.1%2C0c0%2C0%2C0%2C0%2C0.1%2C0l1.2%2C1.2v0.1l-1%2C1.4c-0.1%2C0.2-0.1%2C0.4%2C0%2C0.6c0.3%2C0.5%2C0.6%2C1.1%2C0.7%2C1.6c0.1%2C0.2%2C0.2%2C0.4%2C0.4%2C0.4%09%09%09l1.6%2C0.3c0.1%2C0%2C0.1%2C0.1%2C0.1%2C0.1v1.8H24.6z%20M16%2C11.5c-2.5%2C0-4.5%2C2-4.5%2C4.5s2%2C4.5%2C4.5%2C4.5s4.5-2%2C4.5-4.5S18.5%2C11.5%2C16%2C11.5z%09%09%09%20M16%2C18.8c-1.5%2C0-2.8-1.3-2.8-2.8s1.3-2.8%2C2.8-2.8s2.8%2C1.3%2C2.8%2C2.8S17.5%2C18.8%2C16%2C18.8z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3C/svg%3E");
  max-height: .8em;
  padding: .3em 0;
  vertical-align: bottom; }
  .bmpui-ui-settingspanelpageopenbutton:hover {
    filter: drop-shadow(0 0 1px #fff); }
  .bmpui-on.bmpui-ui-settingspanelpageopenbutton {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20id%3D%22npo-icon-settingsX%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2032%2032%22%20style%3D%22enable-background%3Anew%200%200%2032%2032%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text/css%22%3E%09.st0%7Bopacity%3A0.302%3B%7D%09.st1%7Bfill%3A%23INACTIVE%3B%7D%3C/style%3E%3Cg%20id%3D%22Ellipse_1_copy%22%20class%3D%22st0%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st1%22%20d%3D%22M23.6%2C12.9c-0.5-1.1-0.7-2.2-1.4-3C21.3%2C9%2C20%2C8.7%2C18.9%2C8.3c-1-0.4-1.7-1-2.9-1S13.9%2C8%2C12.8%2C8.4%09%09%09c-1.1%2C0.5-2.1%2C0.7-3%2C1.4c-0.9%2C0.8-1%2C1.8-1.4%2C2.9c-0.4%2C1.1-1.1%2C2-1.1%2C3.3s0.6%2C2%2C1%2C3.1c0.5%2C1.1%2C0.8%2C2.3%2C1.6%2C3.1%09%09%09c0.8%2C0.8%2C1.8%2C1%2C2.9%2C1.4c1.1%2C0.4%2C2%2C1.1%2C3.2%2C1.1s2.3-0.7%2C3.4-1.2c1.1-0.4%2C1.9-0.6%2C2.8-1.4c0.9-0.9%2C1.1-1.9%2C1.4-3.1%09%09%09c0.4-1%2C1.2-2%2C1.2-3.1C24.7%2C14.8%2C24%2C13.9%2C23.6%2C12.9z%20M16%2C19.9c-2.1%2C0-3.9-1.7-3.9-3.9s1.7-3.9%2C3.9-3.9s3.9%2C1.7%2C3.9%2C3.9%09%09%09S18.1%2C19.9%2C16%2C19.9z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3Cg%20id%3D%22Shape_4_1_%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st1%22%20d%3D%22M25.6%2C13.8l-1.4-0.3c-0.2-0.5-0.4-1-0.6-1.4l0.9-1.3c0.4-0.5%2C0.3-1.3-0.1-1.7L23%2C7.7c-0.3-0.3-0.6-0.4-1-0.4%09%09%09c-0.3%2C0-0.6%2C0.1-0.8%2C0.3L20%2C8.5c-0.5-0.3-1-0.5-1.5-0.6l-0.3-1.4c0-0.6-0.6-1.1-1.3-1.1H15c-0.7%2C0-1.2%2C0.5-1.3%2C1.1L13.5%2C8%09%09%09c-0.5%2C0.2-1%2C0.4-1.4%2C0.6l-1.3-0.9c-0.2-0.2-0.5-0.3-0.8-0.3c-0.4%2C0-0.7%2C0.1-1%2C0.4L7.8%2C9.1c-0.5%2C0.5-0.5%2C1.2-0.1%2C1.7l0.9%2C1.3%09%09%09c-0.3%2C0.5-0.5%2C1-0.6%2C1.4l-1.4%2C0.3c-0.7%2C0-1.2%2C0.6-1.2%2C1.3V17c0%2C0.7%2C0.5%2C1.2%2C1.1%2C1.3L8%2C18.5c0.2%2C0.5%2C0.4%2C1%2C0.6%2C1.4l-0.9%2C1.3%09%09%09c-0.4%2C0.5-0.3%2C1.3%2C0.1%2C1.7l1.4%2C1.4c0.3%2C0.3%2C0.6%2C0.4%2C1%2C0.4c0.3%2C0%2C0.6-0.1%2C0.8-0.3l1.3-0.9c0.5%2C0.2%2C1%2C0.4%2C1.4%2C0.6l0.3%2C1.4%09%09%09c0.1%2C0.7%2C0.7%2C1.1%2C1.3%2C1.1H17c0.7%2C0%2C1.2-0.5%2C1.3-1.1l0.3-1.4c0.5-0.2%2C1-0.4%2C1.4-0.6l1.3%2C0.9c0.2%2C0.2%2C0.5%2C0.3%2C0.8%2C0.3%09%09%09c0.4%2C0%2C0.7-0.1%2C1-0.4l1.4-1.4c0.5-0.5%2C0.5-1.2%2C0.1-1.7L23.5%2C20c0.3-0.5%2C0.5-1%2C0.6-1.4l1.4-0.3c0.7-0.1%2C1.1-0.7%2C1.1-1.3V15%09%09%09C26.6%2C14.5%2C26.1%2C13.9%2C25.6%2C13.8z%20M24.6%2C16.9L24.6%2C16.9C24.6%2C17%2C24.6%2C17%2C24.6%2C16.9l-1.8%2C0.4c-0.2%2C0-0.4%2C0.2-0.4%2C0.4%09%09%09c-0.2%2C0.6-0.4%2C1.2-0.7%2C1.6c-0.1%2C0.2-0.1%2C0.4%2C0%2C0.6l1%2C1.4v0.1l-1.2%2C1.2h-0.1c0%2C0%2C0%2C0-0.1%2C0l-1.4-1c-0.2-0.1-0.4-0.1-0.6%2C0%09%09%09c-0.5%2C0.3-1.1%2C0.6-1.6%2C0.7c-0.2%2C0.1-0.4%2C0.2-0.4%2C0.4L17%2C24.5c0%2C0.1-0.1%2C0.1-0.1%2C0.1h-1.7c-0.1%2C0-0.1%2C0-0.1-0.1l-0.3-1.7%09%09%09c0-0.2-0.2-0.4-0.4-0.4c-0.6-0.2-1.2-0.4-1.6-0.7c-0.1%2C0-0.2-0.1-0.3-0.1c-0.1%2C0-0.2%2C0-0.3%2C0.1l-1.4%2C1c0%2C0%2C0%2C0-0.1%2C0%09%09%09c0%2C0%2C0%2C0-0.1%2C0l-1.2-1.2v-0.1l1-1.4c0.1-0.2%2C0.1-0.4%2C0-0.6C10%2C19%2C9.7%2C18.4%2C9.6%2C17.8c-0.1-0.2-0.2-0.4-0.4-0.4L7.5%2C17%09%09%09c-0.1%2C0-0.1-0.1-0.1-0.1v-1.7c0-0.1%2C0-0.1%2C0.1-0.1l1.7-0.2c0.2%2C0%2C0.4-0.2%2C0.5-0.4c0.2-0.6%2C0.4-1.2%2C0.7-1.6c0.1-0.2%2C0.1-0.4%2C0-0.6%09%09%09l-1-1.4v-0.1l1.2-1.2h0.1c0%2C0%2C0%2C0%2C0.1%2C0l1.4%2C1c0.2%2C0.1%2C0.4%2C0.1%2C0.6%2C0c0.5-0.3%2C1.1-0.6%2C1.6-0.7c0.2-0.1%2C0.4-0.2%2C0.4-0.4L15%2C7.5%09%09%09c0-0.1%2C0.1-0.1%2C0.1-0.1h1.7c0.1%2C0%2C0.1%2C0%2C0.1%2C0.1l0.2%2C1.7c0%2C0.2%2C0.2%2C0.4%2C0.4%2C0.5c0.6%2C0.2%2C1.2%2C0.4%2C1.7%2C0.7c0.2%2C0.1%2C0.4%2C0.1%2C0.6%2C0%09%09%09l1.4-1c0%2C0%2C0%2C0%2C0.1%2C0c0%2C0%2C0%2C0%2C0.1%2C0l1.2%2C1.2v0.1l-1%2C1.4c-0.1%2C0.2-0.1%2C0.4%2C0%2C0.6c0.3%2C0.5%2C0.6%2C1.1%2C0.7%2C1.6c0.1%2C0.2%2C0.2%2C0.4%2C0.4%2C0.4%09%09%09l1.6%2C0.3c0.1%2C0%2C0.1%2C0.1%2C0.1%2C0.1v1.8H24.6z%20M16%2C11.5c-2.5%2C0-4.5%2C2-4.5%2C4.5s2%2C4.5%2C4.5%2C4.5s4.5-2%2C4.5-4.5S18.5%2C11.5%2C16%2C11.5z%09%09%09%20M16%2C18.8c-1.5%2C0-2.8-1.3-2.8-2.8s1.3-2.8%2C2.8-2.8s2.8%2C1.3%2C2.8%2C2.8S17.5%2C18.8%2C16%2C18.8z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3C/svg%3E"); }

.bmpui-ui-settingspanelpagebackbutton {
  font-size: .8em;
  position: relative;
  width: 8em; }
  .bmpui-ui-settingspanelpagebackbutton .bmpui-label {
    display: inline-block; }
    .bmpui-ui-settingspanelpagebackbutton .bmpui-label::before {
      border-bottom: 0.2em solid #fff;
      border-left: 0.2em solid #fff;
      content: '';
      height: .6em;
      margin-left: -.8em;
      position: absolute;
      top: .6em;
      transform: rotate(45deg);
      width: .6em; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-settingstogglebutton:hover, .bmpui-ui-subtitlesettingstogglebutton:hover, .bmpui-ui-audiotracksettingstogglebutton:hover {
  filter: drop-shadow(0 0 1px #fff); }

.bmpui-on.bmpui-ui-settingstogglebutton:hover, .bmpui-on.bmpui-ui-subtitlesettingstogglebutton:hover, .bmpui-on.bmpui-ui-audiotracksettingstogglebutton:hover {
  filter: drop-shadow(0 0 1px #1fabe2); }

.bmpui-ui-settingstogglebutton {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20id%3D%22npo-icon-settings%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2032%2032%22%20style%3D%22enable-background%3Anew%200%200%2032%2032%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text/css%22%3E%09.st0%7Bfill%3A%23INACTIVE%3B%7D%3C/style%3E%3Cg%20id%3D%22Shape_4%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st0%22%20d%3D%22M25.6%2C13.8l-1.4-0.3c-0.2-0.5-0.4-1-0.6-1.4l0.9-1.3c0.4-0.5%2C0.3-1.3-0.1-1.7L23%2C7.7c-0.3-0.3-0.6-0.4-1-0.4%09%09%09c-0.3%2C0-0.6%2C0.1-0.8%2C0.3L20%2C8.5c-0.5-0.3-1-0.5-1.5-0.6l-0.3-1.4c0-0.6-0.6-1.1-1.3-1.1H15c-0.7%2C0-1.2%2C0.5-1.3%2C1.1L13.5%2C8%09%09%09c-0.5%2C0.2-1%2C0.4-1.4%2C0.6l-1.3-0.9c-0.2-0.2-0.5-0.3-0.8-0.3c-0.4%2C0-0.7%2C0.1-1%2C0.4L7.8%2C9.1c-0.5%2C0.5-0.5%2C1.2-0.1%2C1.7l0.9%2C1.3%09%09%09c-0.3%2C0.5-0.5%2C1-0.6%2C1.4l-1.4%2C0.3c-0.7%2C0-1.2%2C0.6-1.2%2C1.3V17c0%2C0.7%2C0.5%2C1.2%2C1.1%2C1.3L8%2C18.5c0.2%2C0.5%2C0.4%2C1%2C0.6%2C1.4l-0.9%2C1.3%09%09%09c-0.4%2C0.5-0.3%2C1.3%2C0.1%2C1.7l1.4%2C1.4c0.3%2C0.3%2C0.6%2C0.4%2C1%2C0.4c0.3%2C0%2C0.6-0.1%2C0.8-0.3l1.3-0.9c0.5%2C0.2%2C1%2C0.4%2C1.4%2C0.6l0.3%2C1.4%09%09%09c0.1%2C0.7%2C0.7%2C1.1%2C1.3%2C1.1H17c0.7%2C0%2C1.2-0.5%2C1.3-1.1l0.3-1.4c0.5-0.2%2C1-0.4%2C1.4-0.6l1.3%2C0.9c0.2%2C0.2%2C0.5%2C0.3%2C0.8%2C0.3%09%09%09c0.4%2C0%2C0.7-0.1%2C1-0.4l1.4-1.4c0.5-0.5%2C0.5-1.2%2C0.1-1.7L23.5%2C20c0.3-0.5%2C0.5-1%2C0.6-1.4l1.4-0.3c0.7-0.1%2C1.1-0.7%2C1.1-1.3V15%09%09%09C26.6%2C14.5%2C26.1%2C13.9%2C25.6%2C13.8z%20M24.6%2C16.9L24.6%2C16.9C24.6%2C17%2C24.6%2C17%2C24.6%2C16.9l-1.8%2C0.4c-0.2%2C0-0.4%2C0.2-0.4%2C0.4%09%09%09c-0.2%2C0.6-0.4%2C1.2-0.7%2C1.6c-0.1%2C0.2-0.1%2C0.4%2C0%2C0.6l1%2C1.4v0.1l-1.2%2C1.2h-0.1c0%2C0%2C0%2C0-0.1%2C0l-1.4-1c-0.2-0.1-0.4-0.1-0.6%2C0%09%09%09c-0.5%2C0.3-1.1%2C0.6-1.6%2C0.7c-0.2%2C0.1-0.4%2C0.2-0.4%2C0.4L17%2C24.5c0%2C0.1-0.1%2C0.1-0.1%2C0.1h-1.7c-0.1%2C0-0.1%2C0-0.1-0.1l-0.3-1.7%09%09%09c0-0.2-0.2-0.4-0.4-0.4c-0.6-0.2-1.2-0.4-1.6-0.7c-0.1%2C0-0.2-0.1-0.3-0.1c-0.1%2C0-0.2%2C0-0.3%2C0.1l-1.4%2C1c0%2C0%2C0%2C0-0.1%2C0%09%09%09c0%2C0%2C0%2C0-0.1%2C0l-1.2-1.2v-0.1l1-1.4c0.1-0.2%2C0.1-0.4%2C0-0.6C10%2C19%2C9.7%2C18.4%2C9.6%2C17.8c-0.1-0.2-0.2-0.4-0.4-0.4L7.5%2C17%09%09%09c-0.1%2C0-0.1-0.1-0.1-0.1v-1.7c0-0.1%2C0-0.1%2C0.1-0.1l1.7-0.2c0.2%2C0%2C0.4-0.2%2C0.5-0.4c0.2-0.6%2C0.4-1.2%2C0.7-1.6c0.1-0.2%2C0.1-0.4%2C0-0.6%09%09%09l-1-1.4v-0.1l1.2-1.2h0.1c0%2C0%2C0%2C0%2C0.1%2C0l1.4%2C1c0.2%2C0.1%2C0.4%2C0.1%2C0.6%2C0c0.5-0.3%2C1.1-0.6%2C1.6-0.7c0.2-0.1%2C0.4-0.2%2C0.4-0.4L15%2C7.5%09%09%09c0-0.1%2C0.1-0.1%2C0.1-0.1h1.7c0.1%2C0%2C0.1%2C0%2C0.1%2C0.1l0.2%2C1.7c0%2C0.2%2C0.2%2C0.4%2C0.4%2C0.5c0.6%2C0.2%2C1.2%2C0.4%2C1.7%2C0.7c0.2%2C0.1%2C0.4%2C0.1%2C0.6%2C0%09%09%09l1.4-1c0%2C0%2C0%2C0%2C0.1%2C0c0%2C0%2C0%2C0%2C0.1%2C0l1.2%2C1.2v0.1l-1%2C1.4c-0.1%2C0.2-0.1%2C0.4%2C0%2C0.6c0.3%2C0.5%2C0.6%2C1.1%2C0.7%2C1.6c0.1%2C0.2%2C0.2%2C0.4%2C0.4%2C0.4%09%09%09l1.6%2C0.3c0.1%2C0%2C0.1%2C0.1%2C0.1%2C0.1v1.8H24.6z%20M16%2C11.5c-2.5%2C0-4.5%2C2-4.5%2C4.5s2%2C4.5%2C4.5%2C4.5s4.5-2%2C4.5-4.5S18.5%2C11.5%2C16%2C11.5z%09%09%09%20M16%2C18.8c-1.5%2C0-2.8-1.3-2.8-2.8s1.3-2.8%2C2.8-2.8s2.8%2C1.3%2C2.8%2C2.8S17.5%2C18.8%2C16%2C18.8z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3C/svg%3E"); }
  .bmpui-ui-settingstogglebutton.bmpui-on {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20id%3D%22npo-icon-settingsX%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2032%2032%22%20style%3D%22enable-background%3Anew%200%200%2032%2032%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text/css%22%3E%09.st0%7Bopacity%3A0.302%3B%7D%09.st1%7Bfill%3A%23INACTIVE%3B%7D%3C/style%3E%3Cg%20id%3D%22Ellipse_1_copy%22%20class%3D%22st0%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st1%22%20d%3D%22M23.6%2C12.9c-0.5-1.1-0.7-2.2-1.4-3C21.3%2C9%2C20%2C8.7%2C18.9%2C8.3c-1-0.4-1.7-1-2.9-1S13.9%2C8%2C12.8%2C8.4%09%09%09c-1.1%2C0.5-2.1%2C0.7-3%2C1.4c-0.9%2C0.8-1%2C1.8-1.4%2C2.9c-0.4%2C1.1-1.1%2C2-1.1%2C3.3s0.6%2C2%2C1%2C3.1c0.5%2C1.1%2C0.8%2C2.3%2C1.6%2C3.1%09%09%09c0.8%2C0.8%2C1.8%2C1%2C2.9%2C1.4c1.1%2C0.4%2C2%2C1.1%2C3.2%2C1.1s2.3-0.7%2C3.4-1.2c1.1-0.4%2C1.9-0.6%2C2.8-1.4c0.9-0.9%2C1.1-1.9%2C1.4-3.1%09%09%09c0.4-1%2C1.2-2%2C1.2-3.1C24.7%2C14.8%2C24%2C13.9%2C23.6%2C12.9z%20M16%2C19.9c-2.1%2C0-3.9-1.7-3.9-3.9s1.7-3.9%2C3.9-3.9s3.9%2C1.7%2C3.9%2C3.9%09%09%09S18.1%2C19.9%2C16%2C19.9z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3Cg%20id%3D%22Shape_4_1_%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st1%22%20d%3D%22M25.6%2C13.8l-1.4-0.3c-0.2-0.5-0.4-1-0.6-1.4l0.9-1.3c0.4-0.5%2C0.3-1.3-0.1-1.7L23%2C7.7c-0.3-0.3-0.6-0.4-1-0.4%09%09%09c-0.3%2C0-0.6%2C0.1-0.8%2C0.3L20%2C8.5c-0.5-0.3-1-0.5-1.5-0.6l-0.3-1.4c0-0.6-0.6-1.1-1.3-1.1H15c-0.7%2C0-1.2%2C0.5-1.3%2C1.1L13.5%2C8%09%09%09c-0.5%2C0.2-1%2C0.4-1.4%2C0.6l-1.3-0.9c-0.2-0.2-0.5-0.3-0.8-0.3c-0.4%2C0-0.7%2C0.1-1%2C0.4L7.8%2C9.1c-0.5%2C0.5-0.5%2C1.2-0.1%2C1.7l0.9%2C1.3%09%09%09c-0.3%2C0.5-0.5%2C1-0.6%2C1.4l-1.4%2C0.3c-0.7%2C0-1.2%2C0.6-1.2%2C1.3V17c0%2C0.7%2C0.5%2C1.2%2C1.1%2C1.3L8%2C18.5c0.2%2C0.5%2C0.4%2C1%2C0.6%2C1.4l-0.9%2C1.3%09%09%09c-0.4%2C0.5-0.3%2C1.3%2C0.1%2C1.7l1.4%2C1.4c0.3%2C0.3%2C0.6%2C0.4%2C1%2C0.4c0.3%2C0%2C0.6-0.1%2C0.8-0.3l1.3-0.9c0.5%2C0.2%2C1%2C0.4%2C1.4%2C0.6l0.3%2C1.4%09%09%09c0.1%2C0.7%2C0.7%2C1.1%2C1.3%2C1.1H17c0.7%2C0%2C1.2-0.5%2C1.3-1.1l0.3-1.4c0.5-0.2%2C1-0.4%2C1.4-0.6l1.3%2C0.9c0.2%2C0.2%2C0.5%2C0.3%2C0.8%2C0.3%09%09%09c0.4%2C0%2C0.7-0.1%2C1-0.4l1.4-1.4c0.5-0.5%2C0.5-1.2%2C0.1-1.7L23.5%2C20c0.3-0.5%2C0.5-1%2C0.6-1.4l1.4-0.3c0.7-0.1%2C1.1-0.7%2C1.1-1.3V15%09%09%09C26.6%2C14.5%2C26.1%2C13.9%2C25.6%2C13.8z%20M24.6%2C16.9L24.6%2C16.9C24.6%2C17%2C24.6%2C17%2C24.6%2C16.9l-1.8%2C0.4c-0.2%2C0-0.4%2C0.2-0.4%2C0.4%09%09%09c-0.2%2C0.6-0.4%2C1.2-0.7%2C1.6c-0.1%2C0.2-0.1%2C0.4%2C0%2C0.6l1%2C1.4v0.1l-1.2%2C1.2h-0.1c0%2C0%2C0%2C0-0.1%2C0l-1.4-1c-0.2-0.1-0.4-0.1-0.6%2C0%09%09%09c-0.5%2C0.3-1.1%2C0.6-1.6%2C0.7c-0.2%2C0.1-0.4%2C0.2-0.4%2C0.4L17%2C24.5c0%2C0.1-0.1%2C0.1-0.1%2C0.1h-1.7c-0.1%2C0-0.1%2C0-0.1-0.1l-0.3-1.7%09%09%09c0-0.2-0.2-0.4-0.4-0.4c-0.6-0.2-1.2-0.4-1.6-0.7c-0.1%2C0-0.2-0.1-0.3-0.1c-0.1%2C0-0.2%2C0-0.3%2C0.1l-1.4%2C1c0%2C0%2C0%2C0-0.1%2C0%09%09%09c0%2C0%2C0%2C0-0.1%2C0l-1.2-1.2v-0.1l1-1.4c0.1-0.2%2C0.1-0.4%2C0-0.6C10%2C19%2C9.7%2C18.4%2C9.6%2C17.8c-0.1-0.2-0.2-0.4-0.4-0.4L7.5%2C17%09%09%09c-0.1%2C0-0.1-0.1-0.1-0.1v-1.7c0-0.1%2C0-0.1%2C0.1-0.1l1.7-0.2c0.2%2C0%2C0.4-0.2%2C0.5-0.4c0.2-0.6%2C0.4-1.2%2C0.7-1.6c0.1-0.2%2C0.1-0.4%2C0-0.6%09%09%09l-1-1.4v-0.1l1.2-1.2h0.1c0%2C0%2C0%2C0%2C0.1%2C0l1.4%2C1c0.2%2C0.1%2C0.4%2C0.1%2C0.6%2C0c0.5-0.3%2C1.1-0.6%2C1.6-0.7c0.2-0.1%2C0.4-0.2%2C0.4-0.4L15%2C7.5%09%09%09c0-0.1%2C0.1-0.1%2C0.1-0.1h1.7c0.1%2C0%2C0.1%2C0%2C0.1%2C0.1l0.2%2C1.7c0%2C0.2%2C0.2%2C0.4%2C0.4%2C0.5c0.6%2C0.2%2C1.2%2C0.4%2C1.7%2C0.7c0.2%2C0.1%2C0.4%2C0.1%2C0.6%2C0%09%09%09l1.4-1c0%2C0%2C0%2C0%2C0.1%2C0c0%2C0%2C0%2C0%2C0.1%2C0l1.2%2C1.2v0.1l-1%2C1.4c-0.1%2C0.2-0.1%2C0.4%2C0%2C0.6c0.3%2C0.5%2C0.6%2C1.1%2C0.7%2C1.6c0.1%2C0.2%2C0.2%2C0.4%2C0.4%2C0.4%09%09%09l1.6%2C0.3c0.1%2C0%2C0.1%2C0.1%2C0.1%2C0.1v1.8H24.6z%20M16%2C11.5c-2.5%2C0-4.5%2C2-4.5%2C4.5s2%2C4.5%2C4.5%2C4.5s4.5-2%2C4.5-4.5S18.5%2C11.5%2C16%2C11.5z%09%09%09%20M16%2C18.8c-1.5%2C0-2.8-1.3-2.8-2.8s1.3-2.8%2C2.8-2.8s2.8%2C1.3%2C2.8%2C2.8S17.5%2C18.8%2C16%2C18.8z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3C/svg%3E"); }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-selectbox {
  background-color: transparent;
  border: 0;
  color: #1fabe2;
  cursor: pointer;
  font-size: .8em;
  padding: .3em; }
  .bmpui-ui-selectbox:focus {
    box-shadow: 0 0 0 2px rgba(27, 127, 204, 0.8);
    outline: none; }
  .bmpui-ui-selectbox:focus:not(.bmpui-focus-visible) {
    box-shadow: none;
    outline: none; }
  .bmpui-ui-selectbox option {
    color: #999; }
    .bmpui-ui-selectbox option:checked {
      color: #1fabe2; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-listbox .bmpui-ui-listbox-button {
  box-sizing: border-box;
  display: block;
  font-size: .8em;
  height: 100%;
  min-width: 10em;
  padding: .5em;
  width: 100%; }
  .bmpui-ui-listbox .bmpui-ui-listbox-button .bmpui-label {
    display: inherit; }
  .bmpui-ui-listbox .bmpui-ui-listbox-button.bmpui-selected {
    background-color: rgba(31, 171, 226, 0.7); }
  .bmpui-ui-listbox .bmpui-ui-listbox-button:hover {
    background-color: rgba(31, 171, 226, 0.85); }
  .bmpui-ui-listbox .bmpui-ui-listbox-button:last-child {
    border-bottom: 0; }

.bmpui-ui-seekbar-label {
  opacity: 1;
  transition: opacity 0.3s, visibility 0s;
  visibility: visible;
  bottom: 100%;
  left: 0;
  margin-bottom: 1em;
  pointer-events: none;
  position: absolute;
  text-align: center; }
  .bmpui-ui-seekbar-label.bmpui-hidden {
    opacity: 0;
    transition: opacity 0.3s, visibility 0.3s;
    visibility: hidden; }
  .bmpui-ui-seekbar-label > .bmpui-container-wrapper {
    margin-left: -50%;
    margin-right: 50%;
    position: relative; }
  .bmpui-ui-seekbar-label .bmpui-seekbar-label-inner {
    border-bottom: 0.2em solid #fff; }
    .bmpui-ui-seekbar-label .bmpui-seekbar-label-inner::after {
      border: solid transparent;
      border-color: transparent;
      border-top-color: #fff;
      border-width: .5em;
      content: ' ';
      height: 0;
      left: 50%;
      margin-left: -.5em;
      pointer-events: none;
      position: absolute;
      top: 100%;
      width: 0; }
    .bmpui-ui-seekbar-label .bmpui-seekbar-label-inner > .bmpui-container-wrapper {
      position: relative; }
      .bmpui-ui-seekbar-label .bmpui-seekbar-label-inner > .bmpui-container-wrapper .bmpui-seekbar-thumbnail {
        width: 6em; }
      .bmpui-ui-seekbar-label .bmpui-seekbar-label-inner > .bmpui-container-wrapper .bmpui-seekbar-label-metadata {
        background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7));
        bottom: 0;
        box-sizing: border-box;
        display: block;
        padding: .5em;
        position: absolute;
        width: 100%; }
        .bmpui-ui-seekbar-label .bmpui-seekbar-label-inner > .bmpui-container-wrapper .bmpui-seekbar-label-metadata .bmpui-seekbar-label-time {
          display: block;
          line-height: .8em; }
        .bmpui-ui-seekbar-label .bmpui-seekbar-label-inner > .bmpui-container-wrapper .bmpui-seekbar-label-metadata .bmpui-seekbar-label-title {
          display: block;
          margin-bottom: .3em;
          white-space: normal; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-seekbar, .bmpui-ui-volumeslider {
  cursor: pointer;
  font-size: 1em;
  height: 1em;
  position: relative;
  width: 100%; }
  .bmpui-hidden.bmpui-ui-seekbar, .bmpui-hidden.bmpui-ui-volumeslider {
    display: none; }
  .bmpui-ui-seekbar:focus, .bmpui-ui-volumeslider:focus {
    box-shadow: 0 0 0 2px rgba(27, 127, 204, 0.8);
    outline: none; }
  .bmpui-ui-seekbar:focus:not(.bmpui-focus-visible), .bmpui-ui-volumeslider:focus:not(.bmpui-focus-visible) {
    box-shadow: none;
    outline: none; }
  .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-backdrop, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-backdrop, .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-bufferlevel, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-bufferlevel, .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-seekposition, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-seekposition, .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-playbackposition, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-playbackposition, .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-playbackposition-marker, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-playbackposition-marker, .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-markers, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-markers, .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-markers > .bmpui-seekbar-marker, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-markers > .bmpui-seekbar-marker {
    -ms-transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
    bottom: 0;
    box-sizing: border-box;
    height: 0.3125em;
    left: 0;
    margin: auto;
    position: absolute;
    right: auto;
    top: 0;
    transform-origin: 0 0;
    width: 100%; }
  .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-backdrop, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-backdrop {
    background-color: rgba(255, 255, 255, 0.2);
    margin: auto 0;
    width: 100%; }
  .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-bufferlevel, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-bufferlevel {
    background-color: #fff;
    margin: auto 0;
    transition: .3s linear, .3s linear;
    transition-property: transform; }
  .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-seekposition, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-seekposition {
    background-color: rgba(255, 255, 255, 0.2);
    margin: auto 0; }
  .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-playbackposition, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-playbackposition {
    background-color: #1fabe2;
    margin: auto 0;
    transition: .1s linear, .1s linear;
    transition-property: transform; }
  .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-playbackposition-marker, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-playbackposition-marker {
    height: 0.9375em;
    left: -0.46875em;
    width: 0.9375em;
    background-color: rgba(31, 171, 226, 0.5);
    border: solid #1fabe2 0.1875em;
    border-radius: 50%; }
  .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-markers, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-markers {
    height: 0.5625em; }
    .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-markers > .bmpui-seekbar-marker, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-markers > .bmpui-seekbar-marker {
      background-color: #fff;
      height: 100%;
      width: 2px;
      text-align: center;
      transition-property: transform;
      transition-duration: 1s;
      transition-timing-function: linear; }
      .bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-markers > .bmpui-seekbar-marker > .bmpui-seekbar-marker-image, .bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-markers > .bmpui-seekbar-marker > .bmpui-seekbar-marker-image {
        position: absolute;
        height: 1.25em;
        transform: translate(-50%, calc(-100% - .2em)); }
  .bmpui-seeking.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-bufferlevel, .bmpui-seeking.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-bufferlevel,
  .bmpui-seeking.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-playbackposition,
  .bmpui-seeking.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-playbackposition {
    transition: none; }
  .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar {
    height: 100%;
    width: auto; }
    .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-backdrop, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-backdrop, .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-bufferlevel, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-bufferlevel, .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-seekposition, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-seekposition, .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-playbackposition, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-playbackposition {
      right: 0;
      top: auto; }
    .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-playbackposition .bmpui-seekbar-playbackposition-marker, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-playbackposition .bmpui-seekbar-playbackposition-marker {
      height: 1em;
      top: -.5em;
      width: 100%; }
    .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-backdrop, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-backdrop {
      height: 100%;
      margin: 0 auto;
      width: auto; }
    .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-bufferlevel, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-bufferlevel {
      margin: 0 auto; }
    .bmpui-vertical.bmpui-ui-seekbar .bmpui-seekbar .bmpui-seekbar-seekposition, .bmpui-vertical.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-seekposition {
      margin: 0 auto; }

.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-playbackposition-marker {
  height: 0.6875em;
  left: -0.34375em;
  width: 0.6875em;
  background-color: #1fabe2;
  border: 0; }

.bmpui-ui-volumeslider .bmpui-seekbar .bmpui-seekbar-bufferlevel {
  display: none; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-uicontainer .bmpui-ui-subtitle-overlay {
  bottom: 0;
  font-size: 1.2em;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  transition: bottom 0.15s ease-out; }
  .bmpui-ui-uicontainer .bmpui-ui-subtitle-overlay.bmpui-hidden {
    display: none; }
  .bmpui-ui-uicontainer .bmpui-ui-subtitle-overlay * {
    all: unset; }
  .bmpui-ui-uicontainer .bmpui-ui-subtitle-overlay p {
    display: block; }
  .bmpui-ui-uicontainer .bmpui-ui-subtitle-overlay .bmpui-subtitle-region-container {
    position: absolute; }
    .bmpui-ui-uicontainer .bmpui-ui-subtitle-overlay .bmpui-subtitle-region-container.bmpui-subtitle-position-default {
      bottom: 2em;
      left: 3em;
      right: 3em;
      top: initial; }
    .bmpui-ui-uicontainer .bmpui-ui-subtitle-overlay .bmpui-subtitle-region-container.bmpui-subtitle-position-bottom > div {
      bottom: 0;
      position: absolute;
      width: 100%; }
  .bmpui-ui-uicontainer .bmpui-ui-subtitle-overlay .bmpui-ui-subtitle-label {
    text-shadow: -1px -1px 0 #000, 0 -1px 0 #000, 1px -1px 0 #000, -1px 0 0 #000, 1px 0 0 #000, -1px 1px 0 #000, 0 1px 0 #000, 1px 1px 0 #000;
    color: #fff;
    height: fit-content; }
    .bmpui-ui-uicontainer .bmpui-ui-subtitle-overlay .bmpui-ui-subtitle-label:nth-child(1n-1)::after {
      content: '\A';
      white-space: pre-line;
      height: 0; }
  .bmpui-ui-uicontainer .bmpui-ui-subtitle-overlay.bmpui-controlbar-visible {
    bottom: 5em;
    transition: bottom 0.15s ease-in; }

.bmpui-ui-subtitle-overlay.bmpui-cea608 {
  top: 2em;
  bottom: 2em;
  left: 3em;
  right: 3em; }
  .bmpui-ui-subtitle-overlay.bmpui-cea608 .bmpui-subtitle-region-container.bmpui-subtitle-position-default {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0; }
  .bmpui-ui-subtitle-overlay.bmpui-cea608 .bmpui-ui-subtitle-label {
    font-family: 'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace;
    line-height: 1em;
    position: absolute;
    text-transform: uppercase; }
    .bmpui-ui-subtitle-overlay.bmpui-cea608 .bmpui-ui-subtitle-label:nth-child(1n-1)::after {
      content: normal;
      white-space: normal; }
  .bmpui-ui-subtitle-overlay.bmpui-cea608.bmpui-controlbar-visible {
    bottom: 2em;
    transition: none; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-volumecontrolbutton {
  line-height: 0;
  position: relative; }
  .bmpui-ui-volumecontrolbutton .bmpui-ui-volumeslider {
    background-color: #111;
    bottom: 100%;
    height: 6em;
    position: absolute;
    width: 1.5em; }
    .bmpui-ui-volumecontrolbutton .bmpui-ui-volumeslider {
      max-height: 6em;
      transition: max-height 0.15s ease-in; }
    .bmpui-ui-volumecontrolbutton .bmpui-ui-volumeslider.bmpui-hidden {
      max-height: 0;
      transition: max-height 0.15s ease-out; }
    .bmpui-ui-volumecontrolbutton .bmpui-ui-volumeslider .bmpui-seekbar {
      bottom: .5em;
      height: auto;
      left: .3em;
      overflow: hidden;
      position: absolute;
      right: .3em;
      top: .5em;
      width: auto; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-casttogglebutton {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-chromecast%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M3.29285%205.29289C3.48038%205.10536%203.73474%205%203.99995%205H20C20.2652%205%2020.5195%205.10536%2020.7071%205.29289C20.8946%205.48043%2021%205.73478%2021%206V18C21%2018.2652%2020.8946%2018.5196%2020.7071%2018.7071C20.5195%2018.8946%2020.2652%2019%2020%2019H14C13.4477%2019%2013%2019.4477%2013%2020C13%2020.5523%2013.4477%2021%2014%2021H20C20.7956%2021%2021.5587%2020.6839%2022.1213%2020.1213C22.6839%2019.5587%2023%2018.7957%2023%2018V6C23%205.20435%2022.6839%204.44129%2022.1213%203.87868C21.5587%203.31607%2020.7956%203%2020%203H3.99995C3.2043%203%202.44124%203.31607%201.87863%203.87868C1.31602%204.44129%200.999953%205.20435%200.999953%206V8C0.999953%208.55228%201.44767%209%201.99995%209C2.55224%209%202.99995%208.55228%202.99995%208V6C2.99995%205.73478%203.10531%205.48043%203.29285%205.29289ZM2.11049%2011.0561C1.56159%2010.9951%201.06713%2011.3906%201.00608%2011.9395C0.945032%2012.4884%201.34051%2012.9828%201.88941%2013.0439C3.69456%2013.2446%205.37766%2014.0537%206.66196%2015.338C7.94626%2016.6223%208.75531%2018.3054%208.95608%2020.1105C9.01713%2020.6594%209.51159%2021.0549%2010.0605%2020.9939C10.6094%2020.9328%2011.0049%2020.4384%2010.9438%2019.8895C10.6929%2017.633%209.68155%2015.5292%208.07617%2013.9238C6.4708%2012.3184%204.36692%2011.3071%202.11049%2011.0561ZM2.19978%2015.1202C1.65864%2015.0098%201.13049%2015.359%201.02012%2015.9002C0.909759%2016.4413%201.25898%2016.9695%201.80012%2017.0798C2.56884%2017.2366%203.27448%2017.616%203.82923%2018.1707C4.38398%2018.7255%204.76335%2019.4311%204.92012%2020.1998C5.03049%2020.741%205.55864%2021.0902%206.09978%2020.9798C6.64093%2020.8695%206.99015%2020.3413%206.87978%2019.8002C6.64462%2018.6471%206.07557%2017.5886%205.24344%2016.7565C4.41131%2015.9244%203.35285%2015.3553%202.19978%2015.1202ZM1.99995%2019C1.44767%2019%200.999953%2019.4477%200.999953%2020C0.999953%2020.5523%201.44767%2021%201.99995%2021H2.00995C2.56224%2021%203.00995%2020.5523%203.00995%2020C3.00995%2019.4477%202.56224%2019%202.00995%2019H1.99995ZM19%208C19%207.45%2018.55%207%2018%207H6C5.45%207%205%207.45%205%208V8.63C8.96%209.91%2012.09%2013.04%2013.37%2017H18C18.55%2017%2019%2016.55%2019%2016V8Z%22%20fill%3D%22%23ACTIVE%22%3E%3C/path%3E%3C/svg%3E"); }
  .bmpui-ui-casttogglebutton:hover {
    filter: drop-shadow(0 0 1px #fff); }
  .bmpui-ui-casttogglebutton.bmpui-on {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-chromecastX%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M3.99995%205C3.73474%205%203.48038%205.10536%203.29285%205.29289C3.10531%205.48043%202.99995%205.73478%202.99995%206V8C2.99995%208.55228%202.55224%209%201.99995%209C1.44767%209%200.999953%208.55228%200.999953%208V6C0.999953%205.20435%201.31602%204.44129%201.87863%203.87868C2.44124%203.31607%203.2043%203%203.99995%203H20C20.7956%203%2021.5587%203.31607%2022.1213%203.87868C22.6839%204.44129%2023%205.20435%2023%206V18C23%2018.7957%2022.6839%2019.5587%2022.1213%2020.1213C21.5587%2020.6839%2020.7956%2021%2020%2021H14C13.4477%2021%2013%2020.5523%2013%2020C13%2019.4477%2013.4477%2019%2014%2019H20C20.2652%2019%2020.5195%2018.8946%2020.7071%2018.7071C20.8946%2018.5196%2021%2018.2652%2021%2018V6C21%205.73478%2020.8946%205.48043%2020.7071%205.29289C20.5195%205.10536%2020.2652%205%2020%205H3.99995ZM1.00608%2011.9395C1.06713%2011.3906%201.56159%2010.9951%202.11049%2011.0561C4.36692%2011.3071%206.4708%2012.3184%208.07617%2013.9238C9.68155%2015.5292%2010.6929%2017.633%2010.9438%2019.8895C11.0049%2020.4384%2010.6094%2020.9328%2010.0605%2020.9939C9.51159%2021.0549%209.01713%2020.6594%208.95608%2020.1105C8.75531%2018.3054%207.94626%2016.6223%206.66196%2015.338C5.37766%2014.0537%203.69456%2013.2446%201.88941%2013.0439C1.34051%2012.9828%200.945032%2012.4884%201.00608%2011.9395ZM1.02012%2015.9002C1.13049%2015.359%201.65864%2015.0098%202.19978%2015.1202C3.35285%2015.3553%204.41131%2015.9244%205.24344%2016.7565C6.07557%2017.5886%206.64462%2018.6471%206.87978%2019.8002C6.99015%2020.3413%206.64093%2020.8695%206.09978%2020.9798C5.55864%2021.0902%205.03049%2020.741%204.92012%2020.1998C4.76335%2019.4311%204.38398%2018.7255%203.82923%2018.1707C3.27448%2017.616%202.56884%2017.2366%201.80012%2017.0798C1.25898%2016.9695%200.909759%2016.4413%201.02012%2015.9002Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M0.999953%2020C0.999953%2019.4477%201.44767%2019%201.99995%2019H2.00995C2.56224%2019%203.00995%2019.4477%203.00995%2020C3.00995%2020.5523%202.56224%2021%202.00995%2021H1.99995C1.44767%2021%200.999953%2020.5523%200.999953%2020Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3C/svg%3E"); }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-cast-status-overlay {
  height: 100%;
  left: 0;
  margin: 0;
  position: absolute;
  top: 0;
  width: 100%;
  opacity: 1;
  transition: opacity 0.3s, visibility 0s;
  visibility: visible;
  background: #111 url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-chromecast%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M3.29285%205.29289C3.48038%205.10536%203.73474%205%203.99995%205H20C20.2652%205%2020.5195%205.10536%2020.7071%205.29289C20.8946%205.48043%2021%205.73478%2021%206V18C21%2018.2652%2020.8946%2018.5196%2020.7071%2018.7071C20.5195%2018.8946%2020.2652%2019%2020%2019H14C13.4477%2019%2013%2019.4477%2013%2020C13%2020.5523%2013.4477%2021%2014%2021H20C20.7956%2021%2021.5587%2020.6839%2022.1213%2020.1213C22.6839%2019.5587%2023%2018.7957%2023%2018V6C23%205.20435%2022.6839%204.44129%2022.1213%203.87868C21.5587%203.31607%2020.7956%203%2020%203H3.99995C3.2043%203%202.44124%203.31607%201.87863%203.87868C1.31602%204.44129%200.999953%205.20435%200.999953%206V8C0.999953%208.55228%201.44767%209%201.99995%209C2.55224%209%202.99995%208.55228%202.99995%208V6C2.99995%205.73478%203.10531%205.48043%203.29285%205.29289ZM2.11049%2011.0561C1.56159%2010.9951%201.06713%2011.3906%201.00608%2011.9395C0.945032%2012.4884%201.34051%2012.9828%201.88941%2013.0439C3.69456%2013.2446%205.37766%2014.0537%206.66196%2015.338C7.94626%2016.6223%208.75531%2018.3054%208.95608%2020.1105C9.01713%2020.6594%209.51159%2021.0549%2010.0605%2020.9939C10.6094%2020.9328%2011.0049%2020.4384%2010.9438%2019.8895C10.6929%2017.633%209.68155%2015.5292%208.07617%2013.9238C6.4708%2012.3184%204.36692%2011.3071%202.11049%2011.0561ZM2.19978%2015.1202C1.65864%2015.0098%201.13049%2015.359%201.02012%2015.9002C0.909759%2016.4413%201.25898%2016.9695%201.80012%2017.0798C2.56884%2017.2366%203.27448%2017.616%203.82923%2018.1707C4.38398%2018.7255%204.76335%2019.4311%204.92012%2020.1998C5.03049%2020.741%205.55864%2021.0902%206.09978%2020.9798C6.64093%2020.8695%206.99015%2020.3413%206.87978%2019.8002C6.64462%2018.6471%206.07557%2017.5886%205.24344%2016.7565C4.41131%2015.9244%203.35285%2015.3553%202.19978%2015.1202ZM1.99995%2019C1.44767%2019%200.999953%2019.4477%200.999953%2020C0.999953%2020.5523%201.44767%2021%201.99995%2021H2.00995C2.56224%2021%203.00995%2020.5523%203.00995%2020C3.00995%2019.4477%202.56224%2019%202.00995%2019H1.99995ZM19%208C19%207.45%2018.55%207%2018%207H6C5.45%207%205%207.45%205%208V8.63C8.96%209.91%2012.09%2013.04%2013.37%2017H18C18.55%2017%2019%2016.55%2019%2016V8Z%22%20fill%3D%22%23ACTIVE%22%3E%3C/path%3E%3C/svg%3E") center no-repeat;
  background-size: 7em 7em; }
  .bmpui-ui-cast-status-overlay.bmpui-hidden {
    opacity: 0;
    transition: opacity 0.3s, visibility 0.3s;
    visibility: hidden; }
  .bmpui-ui-cast-status-overlay .bmpui-ui-cast-status-label {
    color: #fff;
    font-size: 1.2em;
    left: 0;
    margin: 0 2em;
    pointer-events: none;
    position: absolute;
    right: 0;
    text-align: center;
    top: 65%; }
    .bmpui-ui-cast-status-overlay .bmpui-ui-cast-status-label * {
      pointer-events: none; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-errormessage-overlay {
  height: 100%;
  left: 0;
  margin: 0;
  position: absolute;
  top: 0;
  width: 100%;
  background-color: #111;
  pointer-events: none; }
  .bmpui-ui-errormessage-overlay.bmpui-hidden {
    display: none; }
  .bmpui-ui-errormessage-overlay .bmpui-ui-errormessage-label {
    color: #fff;
    font-size: 1.2em;
    left: 3em;
    position: absolute;
    right: 3em;
    text-align: center;
    user-select: text;
    white-space: pre-line; }
    .bmpui-ui-errormessage-overlay .bmpui-ui-errormessage-label {
      -ms-transform: translateY(-50%);
      top: 50%;
      transform: translateY(-50%); }
    .bmpui-ui-errormessage-overlay .bmpui-ui-errormessage-label ul {
      color: #999;
      font-size: .9em;
      padding: 0; }
      .bmpui-ui-errormessage-overlay .bmpui-ui-errormessage-label ul li {
        list-style: none; }
  .bmpui-ui-errormessage-overlay .bmpui-ui-tvnoisecanvas {
    height: 100%;
    left: 0;
    margin: 0;
    position: absolute;
    top: 0;
    width: 100%;
    filter: blur(4px); }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-titlebar {
  opacity: 1;
  transition: opacity 0.3s, visibility 0s;
  position: absolute;
  top: 0;
  width: 100%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7));
  box-sizing: border-box;
  padding: .5em 1em 1em;
  pointer-events: none; }
  .bmpui-ui-titlebar.bmpui-hidden {
    opacity: 0;
    transition: opacity 0.3s; }
  .bmpui-ui-titlebar > .bmpui-container-wrapper {
    padding: .5em;
    pointer-events: none; }
    .bmpui-ui-titlebar > .bmpui-container-wrapper .bmpui-label-metadata {
      pointer-events: none; }
    .bmpui-ui-titlebar > .bmpui-container-wrapper .bmpui-label-metadata-title {
      cursor: default;
      display: block;
      font-size: 1.2em;
      text-shadow: 0 0 5px #000;
      white-space: normal; }
    .bmpui-ui-titlebar > .bmpui-container-wrapper .bmpui-label-metadata-description {
      color: #e6e6e6;
      cursor: default;
      display: block;
      text-shadow: 0 0 5px #000;
      white-space: normal; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-recommendation-overlay {
  height: 100%;
  left: 0;
  margin: 0;
  position: absolute;
  top: 0;
  width: 100%;
  display: table;
  opacity: 1;
  transition: opacity 0.6s, visibility 0s;
  visibility: visible;
  background-color: rgba(8, 43, 57, 0.7); }
  .bmpui-ui-recommendation-overlay > .bmpui-container-wrapper {
    display: table-cell;
    text-align: center;
    vertical-align: middle; }
  .bmpui-ui-recommendation-overlay.bmpui-hidden {
    opacity: 0;
    transition: opacity 0.6s, visibility 0.6s;
    visibility: hidden; }
  .bmpui-ui-recommendation-overlay > .bmpui-container-wrapper {
    padding: 3em; }
  .bmpui-ui-recommendation-overlay a {
    color: #fff; }
    .bmpui-ui-recommendation-overlay a:hover, .bmpui-ui-recommendation-overlay a:visited {
      color: #fff; }
  .bmpui-ui-recommendation-overlay.bmpui-recommendations .bmpui-ui-hugereplaybutton {
    bottom: 2em;
    left: 2em;
    position: absolute; }
  .bmpui-ui-recommendation-overlay.bmpui-recommendations .bmpui-ui-recommendation-item {
    background-position: center;
    background-size: cover;
    display: inline-block;
    font-size: .7em;
    height: 9em;
    margin: .3em .6em;
    overflow: hidden;
    position: relative;
    text-align: left;
    text-shadow: 0 0 3px #111;
    transform: scale(1);
    transition: transform 0.15s ease-out;
    width: 16em; }
    .bmpui-ui-recommendation-overlay.bmpui-recommendations .bmpui-ui-recommendation-item .bmpui-background {
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7));
      height: 100%;
      position: absolute;
      top: 20%;
      transition: top 0.15s ease-out;
      width: 100%; }
    .bmpui-ui-recommendation-overlay.bmpui-recommendations .bmpui-ui-recommendation-item .bmpui-title {
      bottom: 3em;
      left: 1em;
      position: absolute;
      right: 1em; }
      .bmpui-ui-recommendation-overlay.bmpui-recommendations .bmpui-ui-recommendation-item .bmpui-title .bmpui-innertitle {
        font-size: 1.2em;
        white-space: normal;
        word-break: break-all; }
    .bmpui-ui-recommendation-overlay.bmpui-recommendations .bmpui-ui-recommendation-item .bmpui-duration {
      bottom: 1em;
      left: 1em;
      position: absolute; }
    .bmpui-ui-recommendation-overlay.bmpui-recommendations .bmpui-ui-recommendation-item:hover {
      outline: 2px solid #1fabe2;
      transform: scale(1.05);
      transition: transform 0.15s ease-in; }
      .bmpui-ui-recommendation-overlay.bmpui-recommendations .bmpui-ui-recommendation-item:hover .bmpui-background {
        top: 0;
        transition: top 0.15s ease-in; }

.bmpui-ui-clickoverlay {
  height: 100%;
  left: 0;
  margin: 0;
  position: absolute;
  top: 0;
  width: 100%; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-hugereplaybutton {
  height: 5em;
  outline: none;
  width: 5em; }
  .bmpui-ui-hugereplaybutton .bmpui-image {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20id%3D%22npo-icon-replayX%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2080%2080%22%20style%3D%22enable-background%3Anew%200%200%2080%2080%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text/css%22%3E%09.st0%7Bopacity%3A0.3%3Bfill%3A%23INACTIVE%3B%7D%09.st1%7Bfill%3A%23INACTIVE%3B%7D%3C/style%3E%3Cpath%20class%3D%22st0%22%20d%3D%22M40%2C73.5c-18.5%2C0-33.5-15-33.5-33.5S21.5%2C6.5%2C40%2C6.5s33.5%2C15%2C33.5%2C33.5S58.5%2C73.5%2C40%2C73.5z%22%3E%3C/path%3E%3Cg%20id%3D%22Ellipse_3_copy_2%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st1%22%20d%3D%22M40%2C5C20.7%2C5%2C5%2C20.7%2C5%2C40s15.7%2C35%2C35%2C35s35-15.7%2C35-35S59.3%2C5%2C40%2C5z%20M40%2C72C22.3%2C72%2C8%2C57.7%2C8%2C40S22.3%2C8%2C40%2C8%09%09%09s32%2C14.3%2C32%2C32S57.7%2C72%2C40%2C72z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3Cg%20id%3D%22Ellipse_3%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st1%22%20d%3D%22M54%2C40.3c0-0.1%2C0-0.2%2C0-0.3h-0.1c-0.2-0.6-0.8-1-1.4-1s-1.2%2C0.4-1.4%2C1H51c0%2C6.1-4.9%2C11-11%2C11s-11-4.9-11-11%09%09%09s4.9-11%2C11-11c0.7%2C0%2C1.4%2C0.1%2C2%2C0.2v3.3c0%2C0.2%2C0.1%2C0.3%2C0.3%2C0.4c0.1%2C0%2C0.2%2C0.1%2C0.3%2C0.1s0.2%2C0%2C0.3-0.1l7.8-4.5%09%09%09c0.2-0.1%2C0.2-0.2%2C0.2-0.4s-0.1-0.3-0.2-0.4l-7.8-4.5c-0.2-0.1-0.4-0.1-0.6%2C0c-0.2%2C0.1-0.3%2C0.2-0.3%2C0.4v2.7c-0.7-0.1-1.3-0.2-2-0.2%09%09%09c-7.7%2C0-14%2C6.3-14%2C14s6.3%2C14%2C14%2C14c7.4%2C0%2C13.5-5.8%2C14-13.2c0-0.1%2C0-0.2%2C0-0.3S54%2C40.4%2C54%2C40.3z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 5em;
    height: 100%;
    width: 100%; }

@keyframes spin {
  50% {
    transform: rotate(180deg) scale(1.1); }
  100% {
    transform: rotate(360deg) scale(1); } }
    .bmpui-ui-hugereplaybutton .bmpui-image:hover {
      animation: spin .5s ease-in; }

.bmpui-ui-playbacktimelabel {
  text-transform: uppercase; }
  .bmpui-ui-playbacktimelabel.bmpui-ui-playbacktimelabel-live {
    cursor: pointer; }
    .bmpui-ui-playbacktimelabel.bmpui-ui-playbacktimelabel-live::before {
      color: #999;
      content: '●';
      padding-right: .2em; }
    .bmpui-ui-playbacktimelabel.bmpui-ui-playbacktimelabel-live.bmpui-ui-playbacktimelabel-live-edge::before {
      color: #f00; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-buffering-overlay {
  display: table; }
  .bmpui-ui-buffering-overlay > .bmpui-container-wrapper {
    display: table-cell;
    text-align: center;
    vertical-align: middle; }

.bmpui-ui-buffering-overlay {
  height: 100%;
  left: 0;
  margin: 0;
  position: absolute;
  top: 0;
  width: 100%;
  opacity: 1;
  transition: opacity 0.6s, visibility 0s;
  visibility: visible;
  background-color: rgba(8, 43, 57, 0.7); }
  .bmpui-ui-buffering-overlay.bmpui-hidden {
    opacity: 0;
    transition: opacity 0.6s, visibility 0.6s;
    visibility: hidden; }
  .bmpui-ui-buffering-overlay > .bmpui-container-wrapper {
    padding: 3em; }
  .bmpui-ui-buffering-overlay a {
    color: #fff; }
    .bmpui-ui-buffering-overlay a:hover, .bmpui-ui-buffering-overlay a:visited {
      color: #fff; }
  .bmpui-ui-buffering-overlay .bmpui-ui-buffering-overlay-indicator {
    animation: fancy 2s ease-in infinite;
    background: url("data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20id%3D%22npo-icon-loader%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2032%2032%22%20style%3D%22enable-background%3Anew%200%200%2032%2032%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text/css%22%3E%09.st0%7Bopacity%3A0.302%3B%7D%09.st1%7Bfill-rule%3Aevenodd%3Bclip-rule%3Aevenodd%3Bfill%3A%23INACTIVE%3B%7D%3C/style%3E%3Cg%20id%3D%22Rectangle_3_copy_3%22%20class%3D%22st0%22%3E%09%3Cg%3E%09%09%3Crect%20x%3D%228%22%20y%3D%228%22%20class%3D%22st1%22%20width%3D%2216%22%20height%3D%2216%22%3E%3C/rect%3E%09%3C/g%3E%3C/g%3E%3Cg%20id%3D%22Rectangle_2_copy_13%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st1%22%20d%3D%22M23%2C7H9C7.9%2C7%2C7%2C7.9%2C7%2C9v14c0%2C1.1%2C0.9%2C2%2C2%2C2h14c1.1%2C0%2C2-0.9%2C2-2V9C25%2C7.9%2C24.1%2C7%2C23%2C7z%20M23%2C23H9V9h14V23z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3C/svg%3E") no-repeat center;
    display: inline-block;
    height: 2em;
    margin: .2em;
    width: 2em; }

@keyframes fancy {
  0% {
    opacity: 0;
    transform: scale(1); }
  20% {
    opacity: 1; }
  30% {
    opacity: 1; }
  50% {
    opacity: 0;
    transform: scale(2); }
  100% {
    opacity: 0;
    transform: scale(3); } }
    .bmpui-ui-buffering-overlay .bmpui-ui-buffering-overlay-indicator:nth-child(1) {
      animation-delay: 0s; }
    .bmpui-ui-buffering-overlay .bmpui-ui-buffering-overlay-indicator:nth-child(2) {
      animation-delay: 0.2s; }
    .bmpui-ui-buffering-overlay .bmpui-ui-buffering-overlay-indicator:nth-child(3) {
      animation-delay: 0.4s; }
  .bmpui-ui-buffering-overlay.bmpui-hidden .bmpui-ui-buffering-overlay-indicator {
    display: none; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-playbacktoggle-overlay .bmpui-ui-hugeplaybacktogglebutton {
  height: 100%;
  left: 0;
  margin: 0;
  position: absolute;
  top: 0;
  width: 100%; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-closebutton {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20id%3D%22npo-icon-close%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2032%2032%22%20style%3D%22enable-background%3Anew%200%200%2032%2032%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text/css%22%3E%09.st0%7Bfill%3A%23INACTIVE%3B%7D%3C/style%3E%3Cg%20id%3D%22Rounded_Rectangle_6%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st0%22%20d%3D%22M26%2C6c-0.9-0.9-2.2-0.9-3.1%2C0L6%2C22.8c-0.9%2C0.9-0.9%2C2.2%2C0%2C3.1c0.9%2C0.9%2C2.2%2C0.9%2C3.1%2C0L26%2C9.2%09%09%09C26.9%2C8.3%2C26.9%2C6.9%2C26%2C6z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3Cg%20id%3D%22Rounded_Rectangle_6_copy%22%3E%09%3Cg%3E%09%09%3Cpath%20class%3D%22st0%22%20d%3D%22M26%2C22.8L9.2%2C6C8.3%2C5.1%2C7%2C5.1%2C6.1%2C6s-0.9%2C2.2%2C0%2C3.1l16.9%2C16.9c0.9%2C0.9%2C2.2%2C0.9%2C3.1%2C0%09%09%09C26.9%2C25.1%2C26.9%2C23.7%2C26%2C22.8z%22%3E%3C/path%3E%09%3C/g%3E%3C/g%3E%3C/svg%3E"); }

@keyframes pulsate {
  20% {
    transform: scale(1.1); }
  40% {
    transform: scale(1); }
  60% {
    transform: scale(1.1); }
  80% {
    transform: scale(1); } }
  .bmpui-ui-closebutton:hover {
    filter: drop-shadow(0 0 1px #fff);
    animation: pulsate 1s; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-airplaytogglebutton {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-airplay%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M5%205C4.44772%205%204%205.44772%204%206V14C4%2014.5523%204.44772%2015%205%2015H5.5C6.05228%2015%206.5%2015.4477%206.5%2016C6.5%2016.5523%206.05228%2017%205.5%2017H5C3.34315%2017%202%2015.6569%202%2014V6C2%204.34315%203.34315%203%205%203H19C20.6569%203%2022%204.34315%2022%206V14C22%2015.6569%2020.6569%2017%2019%2017H18.5C17.9477%2017%2017.5%2016.5523%2017.5%2016C17.5%2015.4477%2017.9477%2015%2018.5%2015H19C19.5523%2015%2020%2014.5523%2020%2014V6C20%205.44772%2019.5523%205%2019%205H5ZM11.2287%2013.507C11.6287%2013.022%2012.3716%2013.022%2012.7716%2013.507L17.1898%2018.8637C17.7277%2019.516%2017.2638%2020.5%2016.4183%2020.5H7.58198C6.73651%2020.5%206.27257%2019.516%206.81053%2018.8637L11.2287%2013.507ZM6%208C6%207.44772%206.44772%207%207%207H17C17.5523%207%2018%207.44772%2018%208V12C18%2012.5523%2017.5523%2013%2017%2013H14.9459L14.3144%2012.2344C13.1145%2010.7795%2010.8856%2010.7795%209.68569%2012.2344L9.05423%2013H7C6.44771%2013%206%2012.5523%206%2012V8Z%22%20fill%3D%22%23ACTIVE%22%3E%3C/path%3E%3C/svg%3E"); }
  .bmpui-ui-airplaytogglebutton:hover {
    filter: drop-shadow(0 0 1px #fff); }
  .bmpui-ui-airplaytogglebutton.bmpui-on {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-airplayX%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4%206C4%205.44772%204.44772%205%205%205H19C19.5523%205%2020%205.44772%2020%206V14C20%2014.5523%2019.5523%2015%2019%2015H18.5C17.9477%2015%2017.5%2015.4477%2017.5%2016C17.5%2016.5523%2017.9477%2017%2018.5%2017H19C20.6569%2017%2022%2015.6569%2022%2014V6C22%204.34315%2020.6569%203%2019%203H5C3.34315%203%202%204.34315%202%206V14C2%2015.6569%203.34315%2017%205%2017H5.5C6.05228%2017%206.5%2016.5523%206.5%2016C6.5%2015.4477%206.05228%2015%205.5%2015H5C4.44772%2015%204%2014.5523%204%2014V6ZM12.7716%2013.507C12.3716%2013.022%2011.6287%2013.022%2011.2287%2013.507L6.81053%2018.8637C6.27257%2019.516%206.73651%2020.5%207.58198%2020.5H16.4183C17.2638%2020.5%2017.7277%2019.516%2017.1898%2018.8637L12.7716%2013.507Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3C/svg%3E"); }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-piptogglebutton {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-picinpic1%22%3E%3Cpath%20d%3D%22M16%208L16%207.5V7.5C16%206.09554%2016%205.39331%2015.6629%204.88886C15.517%204.67048%2015.3295%204.48298%2015.1111%204.33706C14.6067%204%2013.9045%204%2012.5%204L6%204C4.11438%204%203.17157%204%202.58579%204.58579C2%205.17157%202%206.11438%202%208L2%2010.5C2%2011.9045%202%2012.6067%202.33706%2013.1111C2.48298%2013.3295%202.67048%2013.517%202.88886%2013.6629C3.39331%2014%204.09554%2014%205.5%2014V14L6%2014%22%20stroke%3D%22%23INACTIVE%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C/path%3E%3Crect%20x%3D%229%22%20y%3D%2211%22%20width%3D%2214%22%20height%3D%2210%22%20rx%3D%222%22%20fill%3D%22%23INACTIVE%22%3E%3C/rect%3E%3Cpath%20d%3D%22M4.77176%206.97556C4.76958%206.86211%204.86212%206.76957%204.97557%206.77175L7.41977%206.81877C7.59607%206.82217%207.68203%207.03547%207.55734%207.16016L5.16017%209.55733C5.03548%209.68202%204.82218%209.59606%204.81879%209.41976L4.77176%206.97556Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3Crect%20x%3D%225.12134%22%20y%3D%227.82843%22%20width%3D%221%22%20height%3D%224%22%20rx%3D%220.5%22%20transform%3D%22rotate%28-45%205.12134%207.82843%29%22%20fill%3D%22%23INACTIVE%22%3E%3C/rect%3E%3C/svg%3E"); }
  .bmpui-ui-piptogglebutton:hover {
    filter: drop-shadow(0 0 1px #fff); }
  .bmpui-ui-piptogglebutton.bmpui-on {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23ACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-picinpic1X%22%3E%3Cpath%20d%3D%22M16%208L16%207.5V7.5C16%206.09554%2016%205.39331%2015.6629%204.88886C15.517%204.67048%2015.3295%204.48298%2015.1111%204.33706C14.6067%204%2013.9045%204%2012.5%204L6%204C4.11438%204%203.17157%204%202.58579%204.58579C2%205.17157%202%206.11438%202%208L2%2010.5C2%2011.9045%202%2012.6067%202.33706%2013.1111C2.48298%2013.3295%202.67048%2013.517%202.88886%2013.6629C3.39331%2014%204.09554%2014%205.5%2014V14L6%2014%22%20stroke%3D%22%23ACTIVE%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C/path%3E%3Crect%20x%3D%229%22%20y%3D%2211%22%20width%3D%2214%22%20height%3D%2210%22%20rx%3D%222%22%20fill%3D%22%23ACTIVE%22%3E%3C/rect%3E%3Cpath%20d%3D%22M4.77176%206.97556C4.76958%206.86211%204.86212%206.76957%204.97557%206.77175L7.41977%206.81877C7.59607%206.82217%207.68203%207.03547%207.55734%207.16016L5.16017%209.55733C5.03548%209.68202%204.82218%209.59606%204.81879%209.41976L4.77176%206.97556Z%22%20fill%3D%22%23ACTIVE%22%3E%3C/path%3E%3Crect%20x%3D%225.12134%22%20y%3D%227.82843%22%20width%3D%221%22%20height%3D%224%22%20rx%3D%220.5%22%20transform%3D%22rotate%28-45%205.12134%207.82843%29%22%20fill%3D%22%23ACTIVE%22%3E%3C/rect%3E%3C/svg%3E"); }

.bmpui-ui-spacer {
  height: 100%;
  width: 100%; }

.bmpui-ui-subtitlesettingsresetbutton {
  font-size: .8em;
  width: 12em; }
  .bmpui-ui-subtitlesettingsresetbutton .bmpui-label {
    display: inline-block; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-subtitle-overlay.bmpui-fontcolor-white100 .bmpui-ui-subtitle-label {
  color: white; }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-white75 .bmpui-ui-subtitle-label {
  color: rgba(255, 255, 255, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-white50 .bmpui-ui-subtitle-label {
  color: rgba(255, 255, 255, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-white25 .bmpui-ui-subtitle-label {
  color: rgba(255, 255, 255, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-black100 .bmpui-ui-subtitle-label {
  color: black; }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-black75 .bmpui-ui-subtitle-label {
  color: rgba(0, 0, 0, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-black50 .bmpui-ui-subtitle-label {
  color: rgba(0, 0, 0, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-black25 .bmpui-ui-subtitle-label {
  color: rgba(0, 0, 0, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-red100 .bmpui-ui-subtitle-label {
  color: red; }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-red75 .bmpui-ui-subtitle-label {
  color: rgba(255, 0, 0, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-red50 .bmpui-ui-subtitle-label {
  color: rgba(255, 0, 0, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-red25 .bmpui-ui-subtitle-label {
  color: rgba(255, 0, 0, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-green100 .bmpui-ui-subtitle-label {
  color: lime; }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-green75 .bmpui-ui-subtitle-label {
  color: rgba(0, 255, 0, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-green50 .bmpui-ui-subtitle-label {
  color: rgba(0, 255, 0, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-green25 .bmpui-ui-subtitle-label {
  color: rgba(0, 255, 0, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-blue100 .bmpui-ui-subtitle-label {
  color: blue; }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-blue75 .bmpui-ui-subtitle-label {
  color: rgba(0, 0, 255, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-blue50 .bmpui-ui-subtitle-label {
  color: rgba(0, 0, 255, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-blue25 .bmpui-ui-subtitle-label {
  color: rgba(0, 0, 255, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-cyan100 .bmpui-ui-subtitle-label {
  color: cyan; }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-cyan75 .bmpui-ui-subtitle-label {
  color: rgba(0, 255, 255, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-cyan50 .bmpui-ui-subtitle-label {
  color: rgba(0, 255, 255, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-cyan25 .bmpui-ui-subtitle-label {
  color: rgba(0, 255, 255, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-yellow100 .bmpui-ui-subtitle-label {
  color: yellow; }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-yellow75 .bmpui-ui-subtitle-label {
  color: rgba(255, 255, 0, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-yellow50 .bmpui-ui-subtitle-label {
  color: rgba(255, 255, 0, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-yellow25 .bmpui-ui-subtitle-label {
  color: rgba(255, 255, 0, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-magenta100 .bmpui-ui-subtitle-label {
  color: magenta; }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-magenta75 .bmpui-ui-subtitle-label {
  color: rgba(255, 0, 255, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-magenta50 .bmpui-ui-subtitle-label {
  color: rgba(255, 0, 255, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-fontcolor-magenta25 .bmpui-ui-subtitle-label {
  color: rgba(255, 0, 255, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-white100 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: white; }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-white75 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(255, 255, 255, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-white50 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(255, 255, 255, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-white25 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(255, 255, 255, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-black100 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: black; }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-black75 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(0, 0, 0, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-black50 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(0, 0, 0, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-black25 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(0, 0, 0, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-red100 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: red; }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-red75 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(255, 0, 0, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-red50 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(255, 0, 0, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-red25 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(255, 0, 0, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-green100 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: lime; }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-green75 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(0, 255, 0, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-green50 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(0, 255, 0, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-green25 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(0, 255, 0, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-blue100 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: blue; }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-blue75 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(0, 0, 255, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-blue50 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(0, 0, 255, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-blue25 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(0, 0, 255, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-cyan100 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: cyan; }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-cyan75 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(0, 255, 255, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-cyan50 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(0, 255, 255, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-cyan25 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(0, 255, 255, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-yellow100 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: yellow; }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-yellow75 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(255, 255, 0, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-yellow50 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(255, 255, 0, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-yellow25 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(255, 255, 0, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-magenta100 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: magenta; }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-magenta75 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(255, 0, 255, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-magenta50 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(255, 0, 255, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-bgcolor-magenta25 .bmpui-subtitle-region-container .bmpui-ui-subtitle-label {
  background-color: rgba(255, 0, 255, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-white100 .bmpui-subtitle-region-container {
  background-color: white; }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-white75 .bmpui-subtitle-region-container {
  background-color: rgba(255, 255, 255, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-white50 .bmpui-subtitle-region-container {
  background-color: rgba(255, 255, 255, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-white25 .bmpui-subtitle-region-container {
  background-color: rgba(255, 255, 255, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-black100 .bmpui-subtitle-region-container {
  background-color: black; }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-black75 .bmpui-subtitle-region-container {
  background-color: rgba(0, 0, 0, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-black50 .bmpui-subtitle-region-container {
  background-color: rgba(0, 0, 0, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-black25 .bmpui-subtitle-region-container {
  background-color: rgba(0, 0, 0, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-red100 .bmpui-subtitle-region-container {
  background-color: red; }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-red75 .bmpui-subtitle-region-container {
  background-color: rgba(255, 0, 0, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-red50 .bmpui-subtitle-region-container {
  background-color: rgba(255, 0, 0, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-red25 .bmpui-subtitle-region-container {
  background-color: rgba(255, 0, 0, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-green100 .bmpui-subtitle-region-container {
  background-color: lime; }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-green75 .bmpui-subtitle-region-container {
  background-color: rgba(0, 255, 0, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-green50 .bmpui-subtitle-region-container {
  background-color: rgba(0, 255, 0, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-green25 .bmpui-subtitle-region-container {
  background-color: rgba(0, 255, 0, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-blue100 .bmpui-subtitle-region-container {
  background-color: blue; }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-blue75 .bmpui-subtitle-region-container {
  background-color: rgba(0, 0, 255, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-blue50 .bmpui-subtitle-region-container {
  background-color: rgba(0, 0, 255, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-blue25 .bmpui-subtitle-region-container {
  background-color: rgba(0, 0, 255, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-cyan100 .bmpui-subtitle-region-container {
  background-color: cyan; }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-cyan75 .bmpui-subtitle-region-container {
  background-color: rgba(0, 255, 255, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-cyan50 .bmpui-subtitle-region-container {
  background-color: rgba(0, 255, 255, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-cyan25 .bmpui-subtitle-region-container {
  background-color: rgba(0, 255, 255, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-yellow100 .bmpui-subtitle-region-container {
  background-color: yellow; }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-yellow75 .bmpui-subtitle-region-container {
  background-color: rgba(255, 255, 0, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-yellow50 .bmpui-subtitle-region-container {
  background-color: rgba(255, 255, 0, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-yellow25 .bmpui-subtitle-region-container {
  background-color: rgba(255, 255, 0, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-magenta100 .bmpui-subtitle-region-container {
  background-color: magenta; }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-magenta75 .bmpui-subtitle-region-container {
  background-color: rgba(255, 0, 255, 0.75); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-magenta50 .bmpui-subtitle-region-container {
  background-color: rgba(255, 0, 255, 0.5); }

.bmpui-ui-subtitle-overlay.bmpui-windowcolor-magenta25 .bmpui-subtitle-region-container {
  background-color: rgba(255, 0, 255, 0.25); }

.bmpui-ui-subtitle-overlay.bmpui-fontsize-50 .bmpui-ui-subtitle-label {
  font-size: 0.5em; }

.bmpui-ui-subtitle-overlay.bmpui-fontsize-75 .bmpui-ui-subtitle-label {
  font-size: 0.75em; }

.bmpui-ui-subtitle-overlay.bmpui-fontsize-100 .bmpui-ui-subtitle-label {
  font-size: 1em; }

.bmpui-ui-subtitle-overlay.bmpui-fontsize-150 .bmpui-ui-subtitle-label {
  font-size: 1.5em; }

.bmpui-ui-subtitle-overlay.bmpui-fontsize-200 .bmpui-ui-subtitle-label {
  font-size: 2em; }

.bmpui-ui-subtitle-overlay.bmpui-fontsize-300 .bmpui-ui-subtitle-label {
  font-size: 3em; }

.bmpui-ui-subtitle-overlay.bmpui-fontsize-400 .bmpui-ui-subtitle-label {
  font-size: 4em; }

.bmpui-ui-subtitle-overlay.bmpui-characteredge-none .bmpui-ui-subtitle-label {
  text-shadow: none; }

.bmpui-ui-subtitle-overlay.bmpui-characteredge-raised .bmpui-ui-subtitle-label {
  text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.9), 0px 1px 4px rgba(0, 0, 0, 0.9), 0px 2px 4px rgba(0, 0, 0, 0.9); }

.bmpui-ui-subtitle-overlay.bmpui-characteredge-depressed .bmpui-ui-subtitle-label {
  text-shadow: rgba(0, 0, 0, 0.8) 0px -2px 1px; }

.bmpui-ui-subtitle-overlay.bmpui-characteredge-uniform .bmpui-ui-subtitle-label {
  text-shadow: -2px 0px 1px rgba(0, 0, 0, 0.8), 2px 0px 1px rgba(0, 0, 0, 0.8), 0px -2px 1px rgba(0, 0, 0, 0.8), 0px 2px 1px rgba(0, 0, 0, 0.8), -1px 1px 1px rgba(0, 0, 0, 0.8), 1px 1px 1px rgba(0, 0, 0, 0.8), 1px -1px 1px rgba(0, 0, 0, 0.8), 1px 1px 1px rgba(0, 0, 0, 0.8); }

.bmpui-ui-subtitle-overlay.bmpui-characteredge-dropshadowed .bmpui-ui-subtitle-label {
  text-shadow:  0px 2px 1px rgba(0, 0, 0, 0.8); }

.bmpui-ui-subtitle-overlay.bmpui-fontfamily-monospacedserif .bmpui-ui-subtitle-label {
  font-family: 'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace; }

.bmpui-ui-subtitle-overlay.bmpui-fontfamily-proportionalserif .bmpui-ui-subtitle-label {
  font-family: 'Times New Roman', Times, Georgia, Cambria, 'PT Serif Caption', serif; }

.bmpui-ui-subtitle-overlay.bmpui-fontfamily-monospacedsansserif .bmpui-ui-subtitle-label {
  font-family: 'Deja Vu Sans Mono', 'Lucida Console', Monaco, Consolas, 'PT Mono', monospace; }

.bmpui-ui-subtitle-overlay.bmpui-fontfamily-proportionalsansserif .bmpui-ui-subtitle-label {
  font-family: Roboto, 'Arial Unicode Ms', Arial, Helvetica, Verdana, 'PT Sans Caption', sans-serif; }

.bmpui-ui-subtitle-overlay.bmpui-fontfamily-casual .bmpui-ui-subtitle-label {
  font-family: 'Comic Sans MS', Impact, Handlee, fantasy; }

.bmpui-ui-subtitle-overlay.bmpui-fontfamily-cursive .bmpui-ui-subtitle-label {
  font-family: 'Monotype Corsiva', 'URW Chancery L', 'Apple Chancery', 'Dancing Script', cursive;
  font-style: italic; }

.bmpui-ui-subtitle-overlay.bmpui-fontfamily-smallcapital .bmpui-ui-subtitle-label {
  font-variant: small-caps; }

.bmpui-ui-subtitlesettingstogglebutton {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-subtitles%22%3E%3Crect%20x%3D%222%22%20y%3D%224%22%20width%3D%2220%22%20height%3D%2216%22%20rx%3D%222%22%20stroke%3D%22%23INACTIVE%22%20stroke-width%3D%222%22%3E%3C/rect%3E%3Crect%20x%3D%2211%22%20y%3D%2216%22%20width%3D%229%22%20height%3D%222%22%20rx%3D%221%22%20fill%3D%22%23INACTIVE%22%3E%3C/rect%3E%3Crect%20x%3D%224%22%20y%3D%2216%22%20width%3D%226%22%20height%3D%222%22%20rx%3D%221%22%20fill%3D%22%23INACTIVE%22%3E%3C/rect%3E%3Crect%20x%3D%227%22%20y%3D%2213%22%20width%3D%227%22%20height%3D%222%22%20rx%3D%221%22%20fill%3D%22%23INACTIVE%22%3E%3C/rect%3E%3Crect%20x%3D%2215%22%20y%3D%2213%22%20width%3D%225%22%20height%3D%222%22%20rx%3D%221%22%20fill%3D%22%23INACTIVE%22%3E%3C/rect%3E%3Crect%20x%3D%224%22%20y%3D%2213%22%20width%3D%222%22%20height%3D%222%22%20rx%3D%221%22%20fill%3D%22%23INACTIVE%22%3E%3C/rect%3E%3C/svg%3E"); }
  .bmpui-ui-subtitlesettingstogglebutton.bmpui-on {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-subtitlesX%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4%203C2.34315%203%201%204.34315%201%206V18C1%2019.6569%202.34315%2021%204%2021H20C21.6569%2021%2023%2019.6569%2023%2018V6C23%204.34315%2021.6569%203%2020%203H4ZM11%2017C11%2016.4477%2011.4477%2016%2012%2016H19C19.5523%2016%2020%2016.4477%2020%2017C20%2017.5523%2019.5523%2018%2019%2018H12C11.4477%2018%2011%2017.5523%2011%2017ZM5%2016C4.44772%2016%204%2016.4477%204%2017C4%2017.5523%204.44772%2018%205%2018H9C9.55228%2018%2010%2017.5523%2010%2017C10%2016.4477%209.55228%2016%209%2016H5ZM8%2014C8%2013.4477%208.44772%2013%209%2013H13C13.5523%2013%2014%2013.4477%2014%2014C14%2014.5523%2013.5523%2015%2013%2015H9C8.44772%2015%208%2014.5523%208%2014ZM16%2013C15.4477%2013%2015%2013.4477%2015%2014C15%2014.5523%2015.4477%2015%2016%2015H19C19.5523%2015%2020%2014.5523%2020%2014C20%2013.4477%2019.5523%2013%2019%2013H16ZM4%2014C4%2013.4477%204.44772%2013%205%2013C5.55228%2013%206%2013.4477%206%2014C6%2014.5523%205.55228%2015%205%2015C4.44772%2015%204%2014.5523%204%2014Z%22%20fill%3D%22%23ACTIVE%22%3E%3C/path%3E%3C/svg%3E"); }

.bmpui-ui-audiotracksettingstogglebutton {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20id%3D%22npo-icon-audio-tracks%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2032%2032%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23INACTIVE%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3EArtboard%201%3C/title%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M15.91%2C18.82a.62.62%2C0%2C0%2C1-.35.56.61.61%2C0%2C0%2C1-.65-.09L11.59%2C16.5H9.81a.6.6%2C0%2C0%2C1-.6-.6h0V13.47a.62.62%2C0%2C0%2C1%2C.6-.62h1.78l3.32-2.79a.63.63%2C0%2C0%2C1%2C.87.1.65.65%2C0%2C0%2C1%2C.13.38Zm2.34-.93H18.2a.64.64%2C0%2C0%2C1-.43-.18l-.08-.08a.6.6%2C0%2C0%2C1-.06-.79%2C3.54%2C3.54%2C0%2C0%2C0-.09-4.33.61.61%2C0%2C0%2C1%2C0-.82l.08-.08a.61.61%2C0%2C0%2C1%2C.46-.18.67.67%2C0%2C0%2C1%2C.45.22%2C4.89%2C4.89%2C0%2C0%2C1%2C.13%2C6%2C.61.61%2C0%2C0%2C1-.45.24Zm2.51%2C1.86a.58.58%2C0%2C0%2C1-.44.21h0a.63.63%2C0%2C0%2C1-.43-.17l-.08-.09a.61.61%2C0%2C0%2C1%2C0-.82%2C6.5%2C6.5%2C0%2C0%2C0-.1-8.46.6.6%2C0%2C0%2C1%2C0-.83V9.5a.56.56%2C0%2C0%2C1%2C.44-.17.57.57%2C0%2C0%2C1%2C.44.2%2C7.8%2C7.8%2C0%2C0%2C1%2C.13%2C10.24Z%22%3E%3C/path%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M19.69%2C26.65l-3.56-3.14h-11a2.77%2C2.77%2C0%2C0%2C1-2.64-2.87V8.2A2.74%2C2.74%2C0%2C0%2C1%2C5.17%2C5.35H26.74A2.75%2C2.75%2C0%2C0%2C1%2C29.37%2C8.2V20.62a2.76%2C2.76%2C0%2C0%2C1-2.63%2C2.85H23ZM4.84%2C7.75V21.19h12l2.82%2C2.63%2C2.54-2.65h4.71V7.75Z%22%3E%3C/path%3E%3C/svg%3E"); }
  .bmpui-ui-audiotracksettingstogglebutton.bmpui-on {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20id%3D%22npo-icon-audio-tracksX%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2032%2032%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%2C.cls-2%7Bfill%3A%23INACTIVE%3B%7D.cls-1%7Bopacity%3A0.3%3Bisolation%3Aisolate%3B%7D%3C/style%3E%3C/defs%3E%3Ctitle%3EArtboard%201%3C/title%3E%3Cpolygon%20class%3D%22cls-1%22%20points%3D%2228.02%206.56%2028.02%2021.86%2022.02%2021.86%2020.3%2025.3%2015.37%2022.16%203.87%2022.16%203.87%206.56%2028.02%206.56%22%3E%3C/polygon%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M15.9%2C18.93a.62.62%2C0%2C0%2C1-.35.55.6.6%2C0%2C0%2C1-.64-.08l-3.33-2.79H9.81A.61.61%2C0%2C0%2C1%2C9.2%2C16h0V13.57A.62.62%2C0%2C0%2C1%2C9.81%2C13h1.77l3.33-2.79a.61.61%2C0%2C0%2C1%2C.86.1.62.62%2C0%2C0%2C1%2C.13.37ZM18.24%2C18h0a.63.63%2C0%2C0%2C1-.43-.17l-.08-.09a.61.61%2C0%2C0%2C1-.06-.79%2C3.53%2C3.53%2C0%2C0%2C0-.09-4.32.64.64%2C0%2C0%2C1%2C0-.82l.08-.09a.6.6%2C0%2C0%2C1%2C.46-.17.67.67%2C0%2C0%2C1%2C.45.22%2C4.88%2C4.88%2C0%2C0%2C1%2C.13%2C6%2C.61.61%2C0%2C0%2C1-.45.24Zm2.51%2C1.87a.66.66%2C0%2C0%2C1-.44.21h0a.6.6%2C0%2C0%2C1-.43-.18l-.08-.08a.61.61%2C0%2C0%2C1%2C0-.82%2C6.52%2C6.52%2C0%2C0%2C0-.1-8.47.6.6%2C0%2C0%2C1%2C0-.83V9.61a.62.62%2C0%2C0%2C1%2C.44-.18.58.58%2C0%2C0%2C1%2C.44.21%2C7.79%2C7.79%2C0%2C0%2C1%2C.13%2C10.23Z%22%3E%3C/path%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M19.68%2C26.76l-3.56-3.15h-11a2.74%2C2.74%2C0%2C0%2C1-2.63-2.86V8.31A2.74%2C2.74%2C0%2C0%2C1%2C5.16%2C5.46H26.73a2.75%2C2.75%2C0%2C0%2C1%2C2.63%2C2.85V20.72a2.75%2C2.75%2C0%2C0%2C1-2.63%2C2.85H23ZM4.83%2C7.86V21.3h12l2.83%2C2.63%2C2.53-2.65h4.71V7.86Z%22%3E%3C/path%3E%3C/svg%3E"); }

.bmpui-ui-skin-ads {
  /* Hide the huge playback button overlay while an ad is playing, so a click goes
   * through to the click-through overlay which will register the click and then
   * pause playback. In the paused state, the huge playback toggle button will be
   * shown and continues playback of the ad when clicked.
   */ }
  .bmpui-ui-skin-ads .bmpui-ui-ads-status {
    background-color: rgba(0, 0, 0, 0.7);
    left: 1.5em;
    padding: .5em 1.5em;
    position: absolute;
    top: 1em; }
    .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-ui-label-ad-message {
      color: #999;
      white-space: normal; }
    .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-ui-button-ad-skip .bmpui-label {
      display: inherit; }
      .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-ui-button-ad-skip .bmpui-label:hover {
        text-decoration: underline; }
    .bmpui-ui-skin-ads .bmpui-ui-ads-status .bmpui-ui-button-ad-skip::before {
      color: #1fabe2;
      content: '●';
      padding-left: .5em;
      padding-right: .5em; }
  .bmpui-ui-skin-ads.bmpui-player-state-playing .bmpui-ui-playbacktoggle-overlay {
    display: none; }
  .bmpui-ui-skin-ads.bmpui-ui-skin-smallscreen .bmpui-ui-ads-status {
    bottom: 0;
    left: 0;
    padding: 1em 1.5em;
    top: auto;
    width: 100%; }

.bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-ui-controlbar, .bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-ui-titlebar {
  background: rgba(17, 17, 17, 0.85);
  padding: .3em .5em; }

.bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-ui-controlbar {
  bottom: 10%;
  left: 10%;
  right: 10%;
  width: auto; }

.bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-ui-titlebar {
  left: 10%;
  right: 10%;
  top: 10%;
  width: auto; }

.bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-ui-watermark {
  margin: 0;
  right: 10%;
  top: 10%; }

.bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-ui-subtitle-overlay {
  bottom: 10%; }
  .bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-ui-subtitle-overlay.bmpui-controlbar-visible {
    bottom: 20%; }
  .bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-ui-subtitle-overlay .bmpui-ui-subtitle-label {
    background-color: rgba(0, 0, 0, 0.5);
    box-decoration-break: clone;
    line-height: 2em;
    padding: .3em .5em;
    text-shadow: none;
    display: inline-flex; }

.bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-ui-hugeplaybacktogglebutton .bmpui-image {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-pause%22%3E%3Cpath%20d%3D%22M6%206C6%204.89543%206.89543%204%208%204C9.10457%204%2010%204.89543%2010%206V18C10%2019.1046%209.10457%2020%208%2020C6.89543%2020%206%2019.1046%206%2018V6Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3Cpath%20d%3D%22M14%206C14%204.89543%2014.8954%204%2016%204C17.1046%204%2018%204.89543%2018%206V18C18%2019.1046%2017.1046%2020%2016%2020C14.8954%2020%2014%2019.1046%2014%2018V6Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3C/svg%3E");
  opacity: .7; }

.bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-ui-hugeplaybacktogglebutton.bmpui-on .bmpui-image,
.bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-ui-hugeplaybacktogglebutton.bmpui-off .bmpui-image {
  animation: none;
  transition: none; }

.bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-seekbar-bufferlevel,
.bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-seekbar-playbackposition,
.bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-ui-buffering-overlay,
.bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-ui-titlebar,
.bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-ui-controlbar,
.bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-ui-subtitle-overlay {
  transition: none; }

.bmpui-ui-skin-cast-receiver.bmpui-ui-uicontainer .bmpui-ui-buffering-overlay-indicator {
  display: none; }

/*
 * this will use the existing \`hidden-animated\` mixin and add additional transitions properties
 *
 * Example:
 * @include hidden-animated-with-additional-transitions($animation-duration,
 *         (
 *                 height: (.35s, cubic-bezier(.4, 0, .2, 1)),
 *                 width: (.35s, cubic-bezier(.4, 0, .2, 1))
 *         )
 * );
 */
.bmpui-ui-skin-smallscreen {
  font-size: 1.2em; }
  .bmpui-ui-skin-smallscreen .bmpui-ui-settings-panel {
    height: 100%;
    left: 0;
    margin: 0;
    position: absolute;
    top: 0;
    width: 100%;
    display: table;
    display: flex; }
    .bmpui-ui-skin-smallscreen .bmpui-ui-settings-panel > .bmpui-container-wrapper {
      display: table-cell;
      text-align: center;
      vertical-align: middle; }
    .bmpui-ui-skin-smallscreen .bmpui-ui-settings-panel .bmpui-ui-settings-panel-page {
      min-width: 15em; }
    .bmpui-ui-skin-smallscreen .bmpui-ui-settings-panel > .bmpui-container-wrapper {
      margin: auto; }
    .bmpui-ui-skin-smallscreen .bmpui-ui-settings-panel .bmpui-ui-settings-panel-item {
      text-align: left; }
    .bmpui-ui-skin-smallscreen .bmpui-ui-settings-panel .bmpui-ui-closebutton {
      margin: 2em;
      position: absolute;
      right: 0;
      top: 0; }
  .bmpui-ui-skin-smallscreen .bmpui-ui-watermark {
    display: none; }
  .bmpui-ui-skin-smallscreen .bmpui-ui-titlebar > .bmpui-container-wrapper {
    display: flex; }
    .bmpui-ui-skin-smallscreen .bmpui-ui-titlebar > .bmpui-container-wrapper .bmpui-ui-label {
      align-items: center;
      display: inline-flex;
      font-size: 1em; }
    .bmpui-ui-skin-smallscreen .bmpui-ui-titlebar > .bmpui-container-wrapper .bmpui-label-metadata-title {
      width: 100%; }
  .bmpui-ui-skin-smallscreen .bmpui-ui-cast-status-overlay {
    background: #111; }
    .bmpui-ui-skin-smallscreen .bmpui-ui-cast-status-overlay .bmpui-ui-cast-status-label {
      top: 30%; }
  .bmpui-ui-skin-smallscreen .bmpui-ui-hugeplaybacktogglebutton .bmpui-image {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-play%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7%206.08445C7%204.99428%207.77922%204%208.86233%204C9.22128%204%209.56872%204.11584%209.86512%204.32772L18.1408%2010.2432C19.0091%2010.8639%2019.2422%2012.1267%2018.7349%2013.073C18.5889%2013.3453%2018.3869%2013.5808%2018.1408%2013.7567L9.86512%2019.6721C8.95894%2020.3199%207.79138%2019.9692%207.26553%2018.9885C7.09037%2018.6618%207%2018.2904%207%2017.9154V6.08445Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3C/svg%3E");
    background-size: 4em; }
  .bmpui-ui-skin-smallscreen.bmpui-remote-control .bmpui-ui-hugeplaybacktogglebutton.bmpui-on .bmpui-image {
    animation: none;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23INACTIVE%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20id%3D%22npo-icon-pause%22%3E%3Cpath%20d%3D%22M6%206C6%204.89543%206.89543%204%208%204C9.10457%204%2010%204.89543%2010%206V18C10%2019.1046%209.10457%2020%208%2020C6.89543%2020%206%2019.1046%206%2018V6Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3Cpath%20d%3D%22M14%206C14%204.89543%2014.8954%204%2016%204C17.1046%204%2018%204.89543%2018%206V18C18%2019.1046%2017.1046%2020%2016%2020C14.8954%2020%2014%2019.1046%2014%2018V6Z%22%20fill%3D%22%23INACTIVE%22%3E%3C/path%3E%3C/svg%3E");
    visibility: visible; }
  .bmpui-ui-skin-smallscreen.bmpui-remote-control .bmpui-ui-hugeplaybacktogglebutton.bmpui-off .bmpui-image {
    animation: none; }
  .bmpui-ui-skin-smallscreen.bmpui-layout-max-width-400 .bmpui-ui-settings-panel,
  .bmpui-ui-skin-smallscreen.bmpui-layout-max-width-400 .bmpui-ui-hugeplaybacktogglebutton,
  .bmpui-ui-skin-smallscreen.bmpui-layout-max-width-400 .bmpui-ui-hugereplaybutton,
  .bmpui-ui-skin-smallscreen.bmpui-layout-max-width-400 .bmpui-ui-errormessage-overlay,
  .bmpui-ui-skin-smallscreen.bmpui-layout-max-width-400 .bmpui-ui-buffering-overlay,
  .bmpui-ui-skin-smallscreen.bmpui-layout-max-width-400 .bmpui-ui-subtitle-overlay,
  .bmpui-ui-skin-smallscreen.bmpui-layout-max-width-400 .bmpui-ui-cast-status-overlay {
    font-size: .6em; }
  .bmpui-ui-skin-smallscreen.bmpui-layout-max-width-600 .bmpui-ui-settings-panel,
  .bmpui-ui-skin-smallscreen.bmpui-layout-max-width-600 .bmpui-ui-hugeplaybacktogglebutton,
  .bmpui-ui-skin-smallscreen.bmpui-layout-max-width-600 .bmpui-ui-hugereplaybutton,
  .bmpui-ui-skin-smallscreen.bmpui-layout-max-width-600 .bmpui-ui-errormessage-overlay,
  .bmpui-ui-skin-smallscreen.bmpui-layout-max-width-600 .bmpui-ui-buffering-overlay,
  .bmpui-ui-skin-smallscreen.bmpui-layout-max-width-600 .bmpui-ui-subtitle-overlay,
  .bmpui-ui-skin-smallscreen.bmpui-layout-max-width-600 .bmpui-ui-cast-status-overlay {
    font-size: .8em; }
  .bmpui-ui-skin-smallscreen.bmpui-no-flexbox .bmpui-ui-titlebar > .bmpui-container-wrapper {
    border-spacing: .5em 0;
    display: table;
    width: 100%; }
    .bmpui-ui-skin-smallscreen.bmpui-no-flexbox .bmpui-ui-titlebar > .bmpui-container-wrapper > * {
      display: table-cell;
      vertical-align: middle;
      width: 1em; }
      .bmpui-ui-skin-smallscreen.bmpui-no-flexbox .bmpui-ui-titlebar > .bmpui-container-wrapper > *.bmpui-hidden {
        display: none; }
    .bmpui-ui-skin-smallscreen.bmpui-no-flexbox .bmpui-ui-titlebar > .bmpui-container-wrapper .bmpui-label-metadata-title {
      width: 100%; }

.bmpui-ui-uicontainer {
  color: #fff;
  font-family: sans-serif;
  font-size: 1em;
  text-align: left;
  user-select: none; }
  .bmpui-ui-uicontainer.bmpui-player-state-idle .bmpui-ui-controlbar,
  .bmpui-ui-uicontainer.bmpui-player-state-idle .bmpui-ui-titlebar,
  .bmpui-ui-uicontainer.bmpui-player-state-idle .bmpui-ui-hugeplaybacktogglebutton {
    display: none; }
  .bmpui-ui-uicontainer.bmpui-player-state-finished .bmpui-ui-controlbar,
  .bmpui-ui-uicontainer.bmpui-player-state-finished .bmpui-ui-hugeplaybacktogglebutton {
    display: none; }
  .bmpui-ui-uicontainer .bmpui-text-right {
    text-align: right; }
  .bmpui-ui-uicontainer.bmpui-layout-max-width-400 .bmpui-ui-titlebar .bmpui-label-metadata-description {
    display: none; }
  .bmpui-ui-uicontainer.bmpui-layout-max-width-400 .bmpui-ui-hugeplaybacktogglebutton, .bmpui-ui-uicontainer.bmpui-layout-max-width-600 .bmpui-ui-hugeplaybacktogglebutton {
    font-size: .7em; }
  .bmpui-ui-uicontainer.bmpui-layout-max-width-400 .bmpui-ui-watermark, .bmpui-ui-uicontainer.bmpui-layout-max-width-600 .bmpui-ui-watermark {
    font-size: .7em; }

`